// src/array.ts
import { valsOrNone } from "@quromedical/utils";
var findProp = (key) => (list = []) => {
  const found = list.find((a) => a[key]);
  return found && found[key];
};

// src/duplicate.ts
import { filter, uniq, compact, includes } from "@quromedical/utils";
var getDuplicates = (arr) => {
  const duplicates = filter(arr, (val, i, itt) => includes(itt, val, i + 1));
  return uniq(duplicates);
};
var removeDuplicates = (arr) => {
  const unique = uniq(arr);
  return compact(unique);
};

// src/exists.ts
var isTruthy = (item) => !!item;
var isFalsy = (item) => !item;

// src/coding/audit-event.ts
var AuditEventCode = /* @__PURE__ */ ((AuditEventCode3) => {
  AuditEventCode3["CreatePatient"] = "auditevent.patient.create";
  AuditEventCode3["UpdatePatient"] = "auditevent.patient.update";
  AuditEventCode3["CreateDeviceUseStatement"] = "auditevent.deviceusestatement.create";
  AuditEventCode3["UpdateDeviceUseStatement"] = "auditevent.deviceusestatement.update";
  AuditEventCode3["CreateObservation"] = "auditevent.observation.create";
  AuditEventCode3["UpdateObservation"] = "auditevent.observation.update";
  AuditEventCode3["CreatePractitioner"] = "auditevent.practitioner.create";
  AuditEventCode3["UpdatePractitioner"] = "auditevent.practitioner.update";
  AuditEventCode3["CreateDevice"] = "auditevent.device.create";
  AuditEventCode3["UpdateDevice"] = "auditevent.device.update";
  AuditEventCode3["CreateDeviceMetric"] = "auditevent.devicemetric.create";
  AuditEventCode3["UpdateDeviceMetric"] = "auditevent.devicemetric.update";
  AuditEventCode3["CreateEncounter"] = "auditevent.encounter.create";
  AuditEventCode3["UpdateEncounter"] = "auditevent.encounter.update";
  AuditEventCode3["DeleteEncounter"] = "auditevent.encounter.delete";
  AuditEventCode3["CreateGroup"] = "auditevent.group.create";
  AuditEventCode3["UpdateGroup"] = "auditevent.group.update";
  AuditEventCode3["CreateOrganization"] = "auditevent.organization.create";
  AuditEventCode3["UpdateOrganization"] = "auditevent.organization.update";
  AuditEventCode3["CreateDiagnosticReport"] = "auditevent.diagnosticreport.create";
  AuditEventCode3["UpdateDiagnosticReport"] = "auditevent.diagnosticreport.update";
  AuditEventCode3["CreateRelatedPerson"] = "auditevent.relatedperson.create";
  AuditEventCode3["UpdateRelatedPerson"] = "auditevent.relatedperson.update";
  AuditEventCode3["CreateCoverage"] = "auditevent.coverage.create";
  AuditEventCode3["UpdateCoverage"] = "auditevent.coverage.update";
  AuditEventCode3["CreateServiceRequest"] = "auditevent.servicerequest.create";
  AuditEventCode3["UpdateServiceRequest"] = "auditevent.servicerequest.update";
  AuditEventCode3["CreateMedia"] = "auditevent.media.create";
  AuditEventCode3["UpdateMedia"] = "auditevent.media.update";
  AuditEventCode3["CreateMedicationStatement"] = "auditevent.medicationstatement.create";
  AuditEventCode3["UpdateMedicationStatement"] = "auditevent.medicationstatement.update";
  AuditEventCode3["CreateClinicalImpression"] = "auditevent.clinicalimpression.create";
  AuditEventCode3["UpdateClinicalImpression"] = "auditevent.clinicalimpression.update";
  AuditEventCode3["CreateMedicationRequest"] = "auditevent.medicationrequest.create";
  AuditEventCode3["UpdateMedicationRequest"] = "auditevent.medicationrequest.update";
  AuditEventCode3["CreatePractitionerRole"] = "auditevent.practitionerrole.create";
  AuditEventCode3["CreateClaim"] = "auditevent.claim.create";
  AuditEventCode3["UpdateClaim"] = "auditevent.claim.update";
  AuditEventCode3["CreateClaimResponse"] = "auditevent.claimresponse.create";
  AuditEventCode3["UpdateClaimResponse"] = "auditevent.claimresponse.update";
  AuditEventCode3["CreateChargeItemDefinition"] = "auditevent.chargeitemdefinition.create";
  AuditEventCode3["UpdateChargeItemDefinition"] = "auditevent.chargeitemdefinition.update";
  AuditEventCode3["CreateChargeItem"] = "auditevent.chargeitem.create";
  AuditEventCode3["UpdateChargeItem"] = "auditevent.chargeitem.update";
  AuditEventCode3["CreateSupplyDelivery"] = "auditevent.supplydelivery.create";
  AuditEventCode3["UpdateSupplyDelivery"] = "auditevent.supplydelivery.update";
  AuditEventCode3["CreateTask"] = "auditevent.task.create";
  AuditEventCode3["UpdateTask"] = "auditevent.task.update";
  AuditEventCode3["CreateLocation"] = "auditevent.location.create";
  AuditEventCode3["UpdateLocation"] = "auditevent.location.update";
  AuditEventCode3["CreateCondition"] = "auditevent.condition.create";
  AuditEventCode3["UpdateCondition"] = "auditevent.condition.update";
  AuditEventCode3["CreateLibrary"] = "auditevent.library.create";
  AuditEventCode3["UpdateLibrary"] = "auditevent.library.update";
  AuditEventCode3["CreateRiskAssessment"] = "auditevent.riskassessment.create";
  AuditEventCode3["UpdateRiskAssessment"] = "auditevent.riskassessment.update";
  AuditEventCode3["CreateDocumentReference"] = "auditevent.documentreference.create";
  AuditEventCode3["UpdateDocumentReference"] = "auditevent.documentreference.update";
  AuditEventCode3["EndDeviceUseStatement"] = "auditevent.deviceusestatement.end";
  AuditEventCode3["StartDeviceUseStatement"] = "auditevent.deviceusestatement.start";
  AuditEventCode3["CancelDeviceUseStatement"] = "auditevent.deviceusestatement.cancel";
  AuditEventCode3["EndObservation"] = "auditevent.observation.end";
  AuditEventCode3["StartObservation"] = "auditevent.observation.start";
  AuditEventCode3["CancelObservation"] = "auditevent.observation.cancel";
  AuditEventCode3["DischargePatient"] = "auditevent.patient.discharge";
  AuditEventCode3["ReadmitPatient"] = "auditevent.patient.readmit";
  AuditEventCode3["OnboardPatient"] = "auditevent.patient.onboard";
  AuditEventCode3["UpdateClaimTemplate"] = "auditevent.claimtemplate.update";
  AuditEventCode3["ResumeAdmission"] = "auditevent.admission.resume";
  AuditEventCode3["PauseAdmission"] = "auditevent.admission.pause";
  AuditEventCode3["InvalidateAdmission"] = "auditevent.admission.invalidate";
  AuditEventCode3["CreateAllergy"] = "auditevent.allergyintolerance.create";
  AuditEventCode3["ReadAllergy"] = "auditevent.allergyintolerance.read";
  AuditEventCode3["UpdateAllergy"] = "auditevent.allergyintolerance.update";
  AuditEventCode3["CreateCommunication"] = "auditevent.communication.create";
  AuditEventCode3["ReadCommunication"] = "auditevent.communication.read";
  AuditEventCode3["UpdateCommunication"] = "auditevent.communication.update";
  AuditEventCode3["CreateCareTeam"] = "auditevent.careteam.create";
  AuditEventCode3["UpdateCareTeam"] = "auditevent.careteam.update";
  AuditEventCode3["CreatePlanDefinition"] = "auditevent.plandefinition.create";
  AuditEventCode3["UpdatePlanDefinition"] = "auditevent.plandefinition.update";
  AuditEventCode3["CreateCarePlan"] = "auditevent.careplan.create";
  AuditEventCode3["UpdateCarePlan"] = "auditevent.careplan.update";
  AuditEventCode3["CreateActivityDefinition"] = "auditevent.activitydefinition.create";
  AuditEventCode3["UpdateActivityDefinition"] = "auditevent.activitydefinition.update";
  AuditEventCode3["CreateQuestionnaire"] = "auditevent.questionnaire.create";
  AuditEventCode3["UpdateQuestionnaire"] = "auditevent.questionnaire.update";
  AuditEventCode3["CreateQuestionnaireResponse"] = "auditevent.questionnaireresponse.create";
  AuditEventCode3["UpdateQuestionnaireResponse"] = "auditevent.questionnaireresponse.update";
  AuditEventCode3["CreateFlag"] = "auditevent.flag.create";
  AuditEventCode3["UpdateFlag"] = "auditevent.flag.update";
  return AuditEventCode3;
})(AuditEventCode || {});
var AuditEventDescription = {
  ["auditevent.patient.create" /* CreatePatient */]: "Create Patient",
  ["auditevent.patient.update" /* UpdatePatient */]: "Update Patient",
  ["auditevent.practitioner.create" /* CreatePractitioner */]: "Create Practitioner",
  ["auditevent.practitioner.update" /* UpdatePractitioner */]: "Update Practitioner",
  ["auditevent.deviceusestatement.create" /* CreateDeviceUseStatement */]: "Create DeviceUseStatement",
  ["auditevent.deviceusestatement.update" /* UpdateDeviceUseStatement */]: "Update DeviceUseStatement",
  ["auditevent.observation.create" /* CreateObservation */]: "Create Observation",
  ["auditevent.observation.update" /* UpdateObservation */]: "Update Observation",
  ["auditevent.device.create" /* CreateDevice */]: "Create Device",
  ["auditevent.device.update" /* UpdateDevice */]: "Update Device",
  ["auditevent.devicemetric.create" /* CreateDeviceMetric */]: "Create DeviceMetric",
  ["auditevent.devicemetric.update" /* UpdateDeviceMetric */]: "Update DeviceMetric",
  ["auditevent.encounter.create" /* CreateEncounter */]: "Create Encounter",
  ["auditevent.encounter.update" /* UpdateEncounter */]: "Update Encounter",
  ["auditevent.group.create" /* CreateGroup */]: "Create Group",
  ["auditevent.group.update" /* UpdateGroup */]: "Update Group",
  ["auditevent.organization.create" /* CreateOrganization */]: "Create Organization",
  ["auditevent.organization.update" /* UpdateOrganization */]: "Update Organization",
  ["auditevent.diagnosticreport.create" /* CreateDiagnosticReport */]: "Create DiagnosticReport",
  ["auditevent.diagnosticreport.update" /* UpdateDiagnosticReport */]: "Update DiagnosticReport",
  ["auditevent.relatedperson.create" /* CreateRelatedPerson */]: "Create RelatedPerson",
  ["auditevent.relatedperson.update" /* UpdateRelatedPerson */]: "Update RelatedPerson",
  ["auditevent.coverage.create" /* CreateCoverage */]: "Create Coverage",
  ["auditevent.coverage.update" /* UpdateCoverage */]: "Update Coverage",
  ["auditevent.servicerequest.create" /* CreateServiceRequest */]: "Create ServiceRequest",
  ["auditevent.servicerequest.update" /* UpdateServiceRequest */]: "Update ServiceRequest",
  ["auditevent.media.create" /* CreateMedia */]: "Create Media",
  ["auditevent.media.update" /* UpdateMedia */]: "Update Media",
  ["auditevent.medicationstatement.create" /* CreateMedicationStatement */]: "Create MedicationStatement",
  ["auditevent.medicationstatement.update" /* UpdateMedicationStatement */]: "Update MedicationStatement",
  ["auditevent.clinicalimpression.create" /* CreateClinicalImpression */]: "Create ClinicalImpression",
  ["auditevent.clinicalimpression.update" /* UpdateClinicalImpression */]: "Update ClinicalImpression",
  ["auditevent.medicationrequest.create" /* CreateMedicationRequest */]: "Create MedicationRequest",
  ["auditevent.medicationrequest.update" /* UpdateMedicationRequest */]: "Update MedicationRequest",
  ["auditevent.claimresponse.create" /* CreateClaimResponse */]: "Create ClaimResponse",
  ["auditevent.claimresponse.update" /* UpdateClaimResponse */]: "Update ClaimResponse",
  ["auditevent.claim.create" /* CreateClaim */]: "Create Claim",
  ["auditevent.claim.update" /* UpdateClaim */]: "Update Claim",
  ["auditevent.task.create" /* CreateTask */]: "Create Task",
  ["auditevent.task.update" /* UpdateTask */]: "Update Task",
  ["auditevent.chargeitemdefinition.create" /* CreateChargeItemDefinition */]: "Create ChargeItemDefinition",
  ["auditevent.chargeitemdefinition.update" /* UpdateChargeItemDefinition */]: "Update ChargeItemDefinition",
  ["auditevent.chargeitem.create" /* CreateChargeItem */]: "Create ChargeItem",
  ["auditevent.chargeitem.update" /* UpdateChargeItem */]: "Update ChargeItem",
  ["auditevent.location.create" /* CreateLocation */]: "Create Location",
  ["auditevent.location.update" /* UpdateLocation */]: "Update Location",
  ["auditevent.condition.create" /* CreateCondition */]: "Create Condition",
  ["auditevent.condition.update" /* UpdateCondition */]: "Update Condition",
  ["auditevent.library.create" /* CreateLibrary */]: "Create Library",
  ["auditevent.library.update" /* UpdateLibrary */]: "Update Library",
  ["auditevent.documentreference.create" /* CreateDocumentReference */]: "Create DocumentReference",
  ["auditevent.documentreference.update" /* UpdateDocumentReference */]: "Update DocumentReference",
  // Special cases
  ["auditevent.deviceusestatement.end" /* EndDeviceUseStatement */]: "Terminate DeviceUseStatement",
  ["auditevent.deviceusestatement.start" /* StartDeviceUseStatement */]: "Start DeviceUseStatement",
  ["auditevent.deviceusestatement.cancel" /* CancelDeviceUseStatement */]: "Cancel DeviceUseStatement",
  ["auditevent.observation.end" /* EndObservation */]: "Terminate Observation",
  ["auditevent.observation.start" /* StartObservation */]: "Start Observation",
  ["auditevent.observation.cancel" /* CancelObservation */]: "Cancel Observation",
  ["auditevent.patient.discharge" /* DischargePatient */]: "Discharge Patient",
  ["auditevent.patient.readmit" /* ReadmitPatient */]: "Readmit Patient",
  ["auditevent.claimtemplate.update" /* UpdateClaimTemplate */]: "Update Claim Template",
  ["auditevent.admission.resume" /* ResumeAdmission */]: "Resume Admission",
  ["auditevent.admission.pause" /* PauseAdmission */]: "Pause Admission",
  ["auditevent.allergyintolerance.update" /* UpdateAllergy */]: "Update AllergyIntolerance",
  ["auditevent.allergyintolerance.create" /* CreateAllergy */]: "Create AllergyIntolerance",
  ["auditevent.communication.create" /* CreateCommunication */]: "Create Communication",
  ["auditevent.careplan.create" /* CreateCarePlan */]: "Create CarePlan",
  ["auditevent.careplan.update" /* UpdateCarePlan */]: "Update CarePlan",
  ["auditevent.careteam.create" /* CreateCareTeam */]: "Create CareTeam",
  ["auditevent.careteam.update" /* UpdateCareTeam */]: "Update CareTeam",
  ["auditevent.plandefinition.create" /* CreatePlanDefinition */]: "Create PlanDefinition",
  ["auditevent.plandefinition.update" /* UpdatePlanDefinition */]: "Update PlanDefinition",
  ["auditevent.activitydefinition.create" /* CreateActivityDefinition */]: "Create ActivityDefinition",
  ["auditevent.activitydefinition.update" /* UpdateActivityDefinition */]: "Update ActivityDefinition",
  ["auditevent.questionnaire.create" /* CreateQuestionnaire */]: "Create Questionnaire",
  ["auditevent.questionnaire.update" /* UpdateQuestionnaire */]: "Update Questionnaire",
  ["auditevent.questionnaireresponse.create" /* CreateQuestionnaireResponse */]: "Create QuestionnaireResponse",
  ["auditevent.questionnaireresponse.update" /* UpdateQuestionnaireResponse */]: "Update QuestionnaireResponse",
  ["auditevent.riskassessment.create" /* CreateRiskAssessment */]: "Create RiskAssessment",
  ["auditevent.riskassessment.update" /* UpdateRiskAssessment */]: "Update RiskAssessment",
  ["auditevent.flag.create" /* CreateFlag */]: "Create Flag",
  ["auditevent.flag.update" /* UpdateFlag */]: "Update Flag"
};

// src/coding/claim.ts
var ClaimPriorityCode = /* @__PURE__ */ ((ClaimPriorityCode2) => {
  ClaimPriorityCode2["Normal"] = "claim.priority.normal";
  return ClaimPriorityCode2;
})(ClaimPriorityCode || {});
var ClaimTypeCode = /* @__PURE__ */ ((ClaimTypeCode2) => {
  ClaimTypeCode2["HospitalAtHome"] = "claim.type.hospitalathome";
  ClaimTypeCode2["TCP"] = "claim.type.tcp";
  ClaimTypeCode2["RemotePatientMonitoring"] = "claim.type.remotepatientmonitoring";
  ClaimTypeCode2["HealingHands"] = "claim.type.healinghands";
  ClaimTypeCode2["Arthroplasty"] = "claim.type.arthroplasty";
  ClaimTypeCode2["InHospitalMonitoring"] = "claim.type.inhospitalmonitoring";
  ClaimTypeCode2["HospitalAtHomeUpgrade"] = "claim.type.hospitalathome.upgrade";
  ClaimTypeCode2["SPHERE"] = "claim.type.sphere";
  return ClaimTypeCode2;
})(ClaimTypeCode || {});

// src/coding/encounter.ts
var EncounterCode = /* @__PURE__ */ ((EncounterCode2) => {
  EncounterCode2["note"] = "encounter.note";
  EncounterCode2["admission"] = "encounter.admission";
  EncounterCode2["automatic"] = "encounter.automatic";
  EncounterCode2["summary"] = "encounter.summary";
  EncounterCode2["discharge"] = "encounter.discharge";
  return EncounterCode2;
})(EncounterCode || {});
var EncounterType = /* @__PURE__ */ ((EncounterType2) => {
  EncounterType2["patch"] = "encounter.type.patch";
  EncounterType2["relay"] = "encounter.type.relay";
  EncounterType2["onboarding"] = "encounter.type.onboarding";
  EncounterType2["homeVisit"] = "encounter.type.homevisit";
  EncounterType2["virtualVisit"] = "encounter.type.virtualvisit";
  EncounterType2["clinicalCallout"] = "encounter.type.clinicalcallout";
  EncounterType2["clinicalUpdate"] = "encounter.type.clinicalupdate";
  EncounterType2["welcomeUpdate"] = "encounter.type.welcome";
  EncounterType2["dischargeUpdate"] = "encounter.type.discharge";
  EncounterType2["bloodResults"] = "encounter.type.bloodresults";
  EncounterType2["physiotherapy"] = "encounter.type.physiotherapy";
  return EncounterType2;
})(EncounterType || {});
var EncounterParticipantType = /* @__PURE__ */ ((EncounterParticipantType2) => {
  EncounterParticipantType2["CreatorPractitioner"] = "encounterparticipant.creator";
  EncounterParticipantType2["NotifyPractitioner"] = "encounterparticipant.notify";
  return EncounterParticipantType2;
})(EncounterParticipantType || {});
var EncounterClass = /* @__PURE__ */ ((EncounterClass2) => {
  EncounterClass2["Home"] = "encounter.class.home";
  EncounterClass2["Hospital"] = "encounter.class.hospital";
  return EncounterClass2;
})(EncounterClass || {});
var EncounterService = /* @__PURE__ */ ((EncounterService2) => {
  EncounterService2["Arthroplasty"] = "encounter.service.arthroplasty";
  EncounterService2["HealingHands"] = "encounter.service.healinghands";
  EncounterService2["HospitalAtHome"] = "encounter.service.hospitalathome";
  EncounterService2["HospitalAtHomeUpgrade"] = "encounter.service.hospitalathome.upgrade";
  EncounterService2["InHospitalMonitoring"] = "encounter.service.inhospitalmonitoring";
  EncounterService2["RemotePatientMonitoring"] = "encounter.service.remotepatientmonitoring";
  EncounterService2["TCP"] = "encounter.service.tcp";
  EncounterService2["SPHERE"] = "encounter.service.sphere";
  return EncounterService2;
})(EncounterService || {});
var encounterServiceDisplay = {
  ["encounter.service.hospitalathome" /* HospitalAtHome */]: "Hospital at Home",
  ["encounter.service.tcp" /* TCP */]: "TCP",
  ["encounter.service.remotepatientmonitoring" /* RemotePatientMonitoring */]: "Remote Patient Monitoring",
  ["encounter.service.healinghands" /* HealingHands */]: "Healing Hands",
  ["encounter.service.arthroplasty" /* Arthroplasty */]: "Arthroplasty",
  ["encounter.service.inhospitalmonitoring" /* InHospitalMonitoring */]: "In-Hospital Monitoring",
  ["encounter.service.hospitalathome.upgrade" /* HospitalAtHomeUpgrade */]: "Hospital at Home Upgrade",
  ["encounter.service.sphere" /* SPHERE */]: "Quro SPHERE"
};
var encounterServiceClaimTypeMap = {
  ["encounter.service.hospitalathome" /* HospitalAtHome */]: "claim.type.hospitalathome" /* HospitalAtHome */,
  ["encounter.service.tcp" /* TCP */]: "claim.type.tcp" /* TCP */,
  ["encounter.service.remotepatientmonitoring" /* RemotePatientMonitoring */]: "claim.type.remotepatientmonitoring" /* RemotePatientMonitoring */,
  ["encounter.service.healinghands" /* HealingHands */]: "claim.type.healinghands" /* HealingHands */,
  ["encounter.service.arthroplasty" /* Arthroplasty */]: "claim.type.arthroplasty" /* Arthroplasty */,
  ["encounter.service.inhospitalmonitoring" /* InHospitalMonitoring */]: "claim.type.inhospitalmonitoring" /* InHospitalMonitoring */,
  ["encounter.service.hospitalathome.upgrade" /* HospitalAtHomeUpgrade */]: "claim.type.hospitalathome.upgrade" /* HospitalAtHomeUpgrade */,
  ["encounter.service.sphere" /* SPHERE */]: "claim.type.sphere" /* SPHERE */
};
var EncounterDischargeReasonCode = /* @__PURE__ */ ((EncounterDischargeReasonCode2) => {
  EncounterDischargeReasonCode2["Completed"] = "encounter.reasonCode.discharge.completed";
  EncounterDischargeReasonCode2["Demised"] = "encounter.reasonCode.discharge.demised";
  EncounterDischargeReasonCode2["RevokeConsent"] = "encounter.reasonCode.discharge.revokeconsent";
  EncounterDischargeReasonCode2["Transfer"] = "encounter.reasonCode.discharge.transfer";
  EncounterDischargeReasonCode2["Upgrade"] = "encounter.reasonCode.discharge.upgrade";
  EncounterDischargeReasonCode2["Rehospitalized"] = "encounter.reasonCode.discharge.rehospitalized";
  return EncounterDischargeReasonCode2;
})(EncounterDischargeReasonCode || {});
var encounterDischargeReasonCodeDisplay = {
  ["encounter.reasonCode.discharge.completed" /* Completed */]: "Completed",
  ["encounter.reasonCode.discharge.demised" /* Demised */]: "Demised",
  ["encounter.reasonCode.discharge.revokeconsent" /* RevokeConsent */]: "Revoke Consent",
  ["encounter.reasonCode.discharge.transfer" /* Transfer */]: "Transfer to other service provider",
  ["encounter.reasonCode.discharge.upgrade" /* Upgrade */]: "Upgrade to another service level",
  ["encounter.reasonCode.discharge.rehospitalized" /* Rehospitalized */]: "Patient has been rehospitalized"
};
var EncounterPausedReasonCode = /* @__PURE__ */ ((EncounterPausedReasonCode2) => {
  EncounterPausedReasonCode2["MIA"] = "encounter.reasonCode.paused.mia";
  EncounterPausedReasonCode2["ReHospitalized"] = "encounter.reasonCode.paused.rehospitalized";
  return EncounterPausedReasonCode2;
})(EncounterPausedReasonCode || {});
var encounterPausedReasonCodeDisplay = {
  ["encounter.reasonCode.paused.mia" /* MIA */]: "Patient is missing in Action",
  ["encounter.reasonCode.paused.rehospitalized" /* ReHospitalized */]: "Patient has been re-hospitalized"
};
var EncounterInvalidateReasonCode = /* @__PURE__ */ ((EncounterInvalidateReasonCode2) => {
  EncounterInvalidateReasonCode2["RefusedConsent"] = "encounter.reasonCode.invalidate.refusedconsent";
  EncounterInvalidateReasonCode2["EscalatedToHospital"] = "encounter.reasonCode.invalidate.escalatedtohospital";
  EncounterInvalidateReasonCode2["RefusedCare"] = "encounter.reasonCode.invalidate.refusedcare";
  return EncounterInvalidateReasonCode2;
})(EncounterInvalidateReasonCode || {});
var encounterInvalidateReasonCodeDisplay = {
  ["encounter.reasonCode.invalidate.refusedconsent" /* RefusedConsent */]: "Refused to give consent",
  ["encounter.reasonCode.invalidate.escalatedtohospital" /* EscalatedToHospital */]: "Escalated to hospital",
  ["encounter.reasonCode.invalidate.refusedcare" /* RefusedCare */]: "Refused care"
};

// src/coding/group.ts
var GroupSecurity = /* @__PURE__ */ ((GroupSecurity2) => {
  GroupSecurity2["PatientCreate"] = "group.security.patient.create";
  GroupSecurity2["PatientRead"] = "group.security.patient.read";
  GroupSecurity2["PatientUpdate"] = "group.security.patient.update";
  GroupSecurity2["PatientReadAll"] = "group.security.patient.read.all";
  GroupSecurity2["PractitionerCreate"] = "group.security.practitioner.create";
  GroupSecurity2["PractitionerRead"] = "group.security.practitioner.read";
  GroupSecurity2["PractitionerUpdate"] = "group.security.practitioner.update";
  GroupSecurity2["EncounterCreate"] = "group.security.encounter.create";
  GroupSecurity2["EncounterRead"] = "group.security.encounter.read";
  GroupSecurity2["EncounterUpdate"] = "group.security.encounter.update";
  GroupSecurity2["DeviceUseStatementCreate"] = "group.security.deviceusestatement.create";
  GroupSecurity2["DeviceUseStatementRead"] = "group.security.deviceusestatement.read";
  GroupSecurity2["DeviceUseStatementUpdate"] = "group.security.deviceusestatement.update";
  GroupSecurity2["ObservationCreate"] = "group.security.observation.create";
  GroupSecurity2["ObservationRead"] = "group.security.observation.read";
  GroupSecurity2["ObservationUpdate"] = "group.security.observation.update";
  GroupSecurity2["DeviceCreate"] = "group.security.device.create";
  GroupSecurity2["DeviceRead"] = "group.security.device.read";
  GroupSecurity2["DeviceUpdate"] = "group.security.device.update";
  GroupSecurity2["GroupCreate"] = "group.security.group.create";
  GroupSecurity2["GroupRead"] = "group.security.group.read";
  GroupSecurity2["GroupUpdate"] = "group.security.group.update";
  GroupSecurity2["OrganizationCreate"] = "group.security.organization.create";
  GroupSecurity2["OrganizationRead"] = "group.security.organization.read";
  GroupSecurity2["OrganizationUpdate"] = "group.security.organization.update";
  GroupSecurity2["DiagnosticReportCreate"] = "group.security.diagnosticreport.create";
  GroupSecurity2["DiagnosticReportRead"] = "group.security.diagnosticreport.read";
  GroupSecurity2["DiagnosticReportUpdate"] = "group.security.diagnosticreport.update";
  GroupSecurity2["RelatedPersonCreate"] = "group.security.relatedperson.create";
  GroupSecurity2["RelatedPersonRead"] = "group.security.relatedperson.read";
  GroupSecurity2["RelatedPersonUpdate"] = "group.security.relatedperson.update";
  GroupSecurity2["CoverageCreate"] = "group.security.coverage.create";
  GroupSecurity2["CoverageRead"] = "group.security.coverage.read";
  GroupSecurity2["CoverageUpdate"] = "group.security.coverage.update";
  GroupSecurity2["ServiceRequestCreate"] = "group.security.servicerequest.create";
  GroupSecurity2["ServiceRequestRead"] = "group.security.servicerequest.read";
  GroupSecurity2["ServiceRequestUpdate"] = "group.security.servicerequest.update";
  GroupSecurity2["ServiceRequestLancet"] = "group.security.lancet";
  GroupSecurity2["MediaCreate"] = "group.security.media.create";
  GroupSecurity2["MediaRead"] = "group.security.media.read";
  GroupSecurity2["MediaUpdate"] = "group.security.media.update";
  GroupSecurity2["MedicationStatementCreate"] = "group.security.medicationstatement.create";
  GroupSecurity2["MedicationStatementRead"] = "group.security.medicationstatement.read";
  GroupSecurity2["MedicationStatementUpdate"] = "group.security.medicationstatement.update";
  GroupSecurity2["MedicationRequestCreate"] = "group.security.medicationrequest.create";
  GroupSecurity2["MedicationRequestRead"] = "group.security.medicationrequest.read";
  GroupSecurity2["MedicationRequestUpdate"] = "group.security.medicationrequest.update";
  GroupSecurity2["MedicationRequestSignForPractitioner"] = "group.security.medicationrequest.sign-for-practitioner";
  GroupSecurity2["ClaimCreate"] = "group.security.claim.create";
  GroupSecurity2["ClaimRead"] = "group.security.claim.read";
  GroupSecurity2["ClaimUpdate"] = "group.security.claim.update";
  GroupSecurity2["ClaimResponseCreate"] = "group.security.claimresponse.create";
  GroupSecurity2["ClaimResponseRead"] = "group.security.claimresponse.read";
  GroupSecurity2["ClaimResponseUpdate"] = "group.security.claimresponse.update";
  GroupSecurity2["ChargeItemDefinitionCreate"] = "group.security.chargeitemdefinition.create";
  GroupSecurity2["ChargeItemDefinitionRead"] = "group.security.chargeitemdefinition.read";
  GroupSecurity2["ChargeItemDefinitionUpdate"] = "group.security.chargeitemdefinition.update";
  GroupSecurity2["ChargeItemCreate"] = "group.security.chargeitem.create";
  GroupSecurity2["ChargeItemRead"] = "group.security.chargeitem.read";
  GroupSecurity2["ChargeItemUpdate"] = "group.security.chargeitem.update";
  GroupSecurity2["ClinicalImpressionCreate"] = "group.security.clinicalimpression.create";
  GroupSecurity2["ClinicalImpressionRead"] = "group.security.clinicalimpression.read";
  GroupSecurity2["ClinicalImpressionUpdate"] = "group.security.clinicalimpression.update";
  GroupSecurity2["DeviceMetricCreate"] = "group.security.devicemetric.create";
  GroupSecurity2["DeviceMetricRead"] = "group.security.devicemetric.read";
  GroupSecurity2["DeviceMetricUpdate"] = "group.security.devicemetric.update";
  GroupSecurity2["ValueSetIcd10Read"] = "group.security.valueset.icd10.read";
  GroupSecurity2["TaskCreate"] = "group.security.task.create";
  GroupSecurity2["TaskUpdate"] = "group.security.task.update";
  GroupSecurity2["TaskRead"] = "group.security.task.read";
  GroupSecurity2["LocationCreate"] = "group.security.location.create";
  GroupSecurity2["LocationUpdate"] = "group.security.location.update";
  GroupSecurity2["LocationRead"] = "group.security.location.read";
  GroupSecurity2["ConditionCreate"] = "group.security.condition.create";
  GroupSecurity2["ConditionUpdate"] = "group.security.condition.update";
  GroupSecurity2["ConditionRead"] = "group.security.condition.read";
  GroupSecurity2["FeaturePreviewNavigator"] = "group.security.featurepreview.navigator";
  GroupSecurity2["FeaturePreviewAISearch"] = "group.security.featurepreview.ai.search";
  GroupSecurity2["FeaturePreviewNotes"] = "group.security.featurepreview.notes";
  GroupSecurity2["VideoConsultCreate"] = "group.security.videoconsult.create";
  GroupSecurity2["VideoConsultInvite"] = "group.security.videoconsult.invite";
  GroupSecurity2["FeaturePreviewAuth0"] = "group.security.featurepreview.auth0";
  GroupSecurity2["FeaturePreviewAI"] = "group.security.featurepreview.ai";
  GroupSecurity2["FeaturePreviewTracking"] = "group.security.featurepreview.tracking";
  GroupSecurity2["AlertEWS"] = "group.security.alert.ews";
  GroupSecurity2["AlertTechRead"] = "group.security.alert.tech-read";
  GroupSecurity2["AlertCommentRead"] = "group.security.alert.comment-read";
  GroupSecurity2["AlertCommentCreate"] = "group.security.alert.comment-create";
  GroupSecurity2["Logistics"] = "group.security.logistics";
  GroupSecurity2["DeviceConfigure"] = "group.security.device.configure";
  GroupSecurity2["ClaimTemplateUpdate"] = "group.security.claimtemplate.update";
  GroupSecurity2["ClaimTemplateRead"] = "group.security.claimtemplate.read";
  GroupSecurity2["ClaimTemplateCreate"] = "group.security.claimtemplate.create";
  GroupSecurity2["CommunicationCreate"] = "group.security.communication.create";
  GroupSecurity2["CommunicationRead"] = "group.security.communication.read";
  GroupSecurity2["AllergyIntoleranceCreate"] = "group.security.allergyintolerance.create";
  GroupSecurity2["AllergyIntoleranceRead"] = "group.security.allergyintolerance.read";
  GroupSecurity2["AllergyIntoleranceUpdate"] = "group.security.allergyintolerance.update";
  GroupSecurity2["CareTeamRead"] = "group.security.careteam.read";
  GroupSecurity2["CareTeamCreate"] = "group.security.careteam.create";
  GroupSecurity2["CareTeamUpdate"] = "group.security.careteam.update";
  GroupSecurity2["LibraryCreate"] = "group.security.library.create";
  GroupSecurity2["LibraryUpdate"] = "group.security.library.update";
  GroupSecurity2["LibraryRead"] = "group.security.library.read";
  GroupSecurity2["Admin"] = "group.security.admin";
  GroupSecurity2["CarePlanRead"] = "group.security.careplan.read";
  GroupSecurity2["CarePlanCreate"] = "group.security.careplan.create";
  GroupSecurity2["CarePlanUpdate"] = "group.security.careplan.update";
  GroupSecurity2["PlanDefinitionRead"] = "group.security.plandefinition.read";
  GroupSecurity2["PlanDefinitionCreate"] = "group.security.plandefinition.create";
  GroupSecurity2["PlanDefinitionUpdate"] = "group.security.plandefinition.update";
  GroupSecurity2["ActivityDefinitionRead"] = "group.security.activitydefinition.read";
  GroupSecurity2["ActivityDefinitionCreate"] = "group.security.activitydefinition.create";
  GroupSecurity2["ActivityDefinitionUpdate"] = "group.security.activitydefinition.update";
  GroupSecurity2["QuestionnaireRead"] = "group.security.questionnaire.read";
  GroupSecurity2["QuestionnaireCreate"] = "group.security.questionnaire.create";
  GroupSecurity2["QuestionnaireUpdate"] = "group.security.questionnaire.update";
  GroupSecurity2["QuestionnaireResponseRead"] = "group.security.questionnaireresponse.read";
  GroupSecurity2["QuestionnaireResponseCreate"] = "group.security.questionnaireresponse.create";
  GroupSecurity2["QuestionnaireResponseUpdate"] = "group.security.questionnaireresponse.update";
  GroupSecurity2["RiskAssessmentCreate"] = "group.security.riskassessment.create";
  GroupSecurity2["RiskAssessmentUpdate"] = "group.security.riskassessment.update";
  GroupSecurity2["RiskAssessmentRead"] = "group.security.riskassessment.read";
  GroupSecurity2["FlagCreate"] = "group.security.flag.create";
  GroupSecurity2["FlagUpdate"] = "group.security.flag.update";
  GroupSecurity2["FlagRead"] = "group.security.flag.read";
  GroupSecurity2["DocumentReferenceCreate"] = "group.security.documentreference.create";
  GroupSecurity2["DocumentReferenceUpdate"] = "group.security.documentreference.update";
  GroupSecurity2["DocumentReferenceRead"] = "group.security.documentreference.read";
  return GroupSecurity2;
})(GroupSecurity || {});
var GroupDescription = {
  ["group.security.device.create" /* DeviceCreate */]: "Create Device",
  ["group.security.device.read" /* DeviceRead */]: "Read Device",
  ["group.security.device.update" /* DeviceUpdate */]: "Update Device",
  ["group.security.encounter.create" /* EncounterCreate */]: "Create Encounter",
  ["group.security.encounter.read" /* EncounterRead */]: "Read Encounter",
  ["group.security.encounter.update" /* EncounterUpdate */]: "Update Encounter",
  ["group.security.deviceusestatement.create" /* DeviceUseStatementCreate */]: "Create DeviceUseStatement",
  ["group.security.deviceusestatement.read" /* DeviceUseStatementRead */]: "Read DeviceUseStatement",
  ["group.security.deviceusestatement.update" /* DeviceUseStatementUpdate */]: "Update DeviceUseStatement",
  ["group.security.observation.create" /* ObservationCreate */]: "Create Observation",
  ["group.security.observation.read" /* ObservationRead */]: "Read Observation",
  ["group.security.observation.update" /* ObservationUpdate */]: "Update Observation",
  ["group.security.patient.create" /* PatientCreate */]: "Create Patient",
  ["group.security.patient.read" /* PatientRead */]: "Read Patient",
  ["group.security.patient.update" /* PatientUpdate */]: "Update Patient",
  ["group.security.patient.read.all" /* PatientReadAll */]: "Read All Patients",
  ["group.security.practitioner.create" /* PractitionerCreate */]: "Create Practitioner",
  ["group.security.practitioner.read" /* PractitionerRead */]: "Read Practitioner",
  ["group.security.practitioner.update" /* PractitionerUpdate */]: "Update Practitioner",
  ["group.security.group.create" /* GroupCreate */]: "Create Group",
  ["group.security.group.read" /* GroupRead */]: "Read Group",
  ["group.security.group.update" /* GroupUpdate */]: "Update Group",
  ["group.security.organization.create" /* OrganizationCreate */]: "Create Organization",
  ["group.security.organization.read" /* OrganizationRead */]: "Read Organization",
  ["group.security.organization.update" /* OrganizationUpdate */]: "Update Organization",
  ["group.security.diagnosticreport.create" /* DiagnosticReportCreate */]: "Create DiagnosticReport",
  ["group.security.diagnosticreport.read" /* DiagnosticReportRead */]: "Read DiagnosticReport",
  ["group.security.diagnosticreport.update" /* DiagnosticReportUpdate */]: "Update DiagnosticReport",
  ["group.security.relatedperson.create" /* RelatedPersonCreate */]: "Create RelatedPerson",
  ["group.security.relatedperson.read" /* RelatedPersonRead */]: "Read RelatedPerson",
  ["group.security.relatedperson.update" /* RelatedPersonUpdate */]: "Update RelatedPerson",
  ["group.security.coverage.create" /* CoverageCreate */]: "Create Coverage",
  ["group.security.coverage.read" /* CoverageRead */]: "Read Coverage",
  ["group.security.coverage.update" /* CoverageUpdate */]: "Update Coverage",
  ["group.security.servicerequest.create" /* ServiceRequestCreate */]: "Create ServiceRequest",
  ["group.security.servicerequest.read" /* ServiceRequestRead */]: "Read ServiceRequest",
  ["group.security.servicerequest.update" /* ServiceRequestUpdate */]: "Update ServiceRequest",
  ["group.security.lancet" /* ServiceRequestLancet */]: "Lancet pathology access",
  ["group.security.media.create" /* MediaCreate */]: "Create Media",
  ["group.security.media.read" /* MediaRead */]: "Read Media",
  ["group.security.media.update" /* MediaUpdate */]: "Update Media",
  ["group.security.medicationstatement.create" /* MedicationStatementCreate */]: "Create MedicationStatement",
  ["group.security.medicationstatement.read" /* MedicationStatementRead */]: "Read MedicationStatement",
  ["group.security.medicationstatement.update" /* MedicationStatementUpdate */]: "Update MedicationStatement",
  ["group.security.medicationrequest.create" /* MedicationRequestCreate */]: "Create MedicationRequest",
  ["group.security.medicationrequest.read" /* MedicationRequestRead */]: "Read MedicationRequest",
  ["group.security.medicationrequest.update" /* MedicationRequestUpdate */]: "Update MedicationRequest",
  ["group.security.medicationrequest.sign-for-practitioner" /* MedicationRequestSignForPractitioner */]: "Sign for practitioner MedicationRequest",
  ["group.security.clinicalimpression.create" /* ClinicalImpressionCreate */]: "Create ClinicalImpression",
  ["group.security.clinicalimpression.read" /* ClinicalImpressionRead */]: "Read ClinicalImpression",
  ["group.security.clinicalimpression.update" /* ClinicalImpressionUpdate */]: "Update ClinicalImpression",
  ["group.security.devicemetric.create" /* DeviceMetricCreate */]: "Create DeviceMetric",
  ["group.security.devicemetric.read" /* DeviceMetricRead */]: "Read DeviceMetric",
  ["group.security.devicemetric.update" /* DeviceMetricUpdate */]: "Update DeviceMetric",
  ["group.security.claim.create" /* ClaimCreate */]: "Create Claim",
  ["group.security.claim.read" /* ClaimRead */]: "Read Claim",
  ["group.security.claim.update" /* ClaimUpdate */]: "Update Claim",
  ["group.security.claimresponse.create" /* ClaimResponseCreate */]: "Create ClaimResponse",
  ["group.security.claimresponse.read" /* ClaimResponseRead */]: "Read ClaimResponse",
  ["group.security.claimresponse.update" /* ClaimResponseUpdate */]: "Update ClaimResponse",
  ["group.security.chargeitemdefinition.create" /* ChargeItemDefinitionCreate */]: "Create ChargeItemDefinition",
  ["group.security.chargeitemdefinition.read" /* ChargeItemDefinitionRead */]: "Read ChargeItemDefinition",
  ["group.security.chargeitemdefinition.update" /* ChargeItemDefinitionUpdate */]: "Update ChargeItemDefinition",
  ["group.security.task.create" /* TaskCreate */]: "Create Task",
  ["group.security.task.read" /* TaskRead */]: "Read Task",
  ["group.security.task.update" /* TaskUpdate */]: "Update Task",
  ["group.security.chargeitem.create" /* ChargeItemCreate */]: "Create ChargeItem",
  ["group.security.chargeitem.read" /* ChargeItemRead */]: "Read ChargeItem",
  ["group.security.chargeitem.update" /* ChargeItemUpdate */]: "Update ChargeItem",
  ["group.security.location.create" /* LocationCreate */]: "Create Location",
  ["group.security.location.read" /* LocationRead */]: "Read Location",
  ["group.security.location.update" /* LocationUpdate */]: "Update Location",
  ["group.security.condition.create" /* ConditionCreate */]: "Create Condition",
  ["group.security.condition.read" /* ConditionRead */]: "Read Condition",
  ["group.security.condition.update" /* ConditionUpdate */]: "Update Condition",
  ["group.security.communication.create" /* CommunicationCreate */]: "Create Communication",
  ["group.security.communication.read" /* CommunicationRead */]: "Read Communication",
  ["group.security.library.read" /* LibraryRead */]: "Read Library",
  ["group.security.library.create" /* LibraryCreate */]: "Create Library",
  ["group.security.library.update" /* LibraryUpdate */]: "Update Library",
  ["group.security.documentreference.create" /* DocumentReferenceCreate */]: "Create DocumentReference",
  ["group.security.documentreference.read" /* DocumentReferenceRead */]: "Read DocumentReference",
  ["group.security.documentreference.update" /* DocumentReferenceUpdate */]: "Update DocumentReference",
  // special permissions
  ["group.security.valueset.icd10.read" /* ValueSetIcd10Read */]: "Read ValueSet ICD10",
  ["group.security.featurepreview.navigator" /* FeaturePreviewNavigator */]: "Feature Preview Navigator",
  ["group.security.featurepreview.ai.search" /* FeaturePreviewAISearch */]: "Feature Preview AI Search",
  ["group.security.featurepreview.notes" /* FeaturePreviewNotes */]: "Feature Preview Notes",
  ["group.security.videoconsult.create" /* VideoConsultCreate */]: "Video Consult Create",
  ["group.security.videoconsult.invite" /* VideoConsultInvite */]: "Video Consult Invite",
  ["group.security.featurepreview.auth0" /* FeaturePreviewAuth0 */]: "Feature Preview Auth0",
  ["group.security.featurepreview.ai" /* FeaturePreviewAI */]: "Feature Preview AI",
  ["group.security.featurepreview.tracking" /* FeaturePreviewTracking */]: "Feature Preview Tracking",
  ["group.security.alert.ews" /* AlertEWS */]: "Early Warning Score Alert",
  ["group.security.alert.comment-read" /* AlertCommentRead */]: "Alert Comment Read",
  ["group.security.alert.comment-create" /* AlertCommentCreate */]: "Alert Comment Create",
  ["group.security.alert.tech-read" /* AlertTechRead */]: "Alert Tech Read",
  ["group.security.logistics" /* Logistics */]: "Logistics",
  ["group.security.device.configure" /* DeviceConfigure */]: "Calibrate Device",
  ["group.security.claimtemplate.read" /* ClaimTemplateRead */]: "Read Claim Template",
  ["group.security.claimtemplate.update" /* ClaimTemplateUpdate */]: "Update Claim Template",
  ["group.security.claimtemplate.create" /* ClaimTemplateCreate */]: "Create Claim Template",
  ["group.security.allergyintolerance.read" /* AllergyIntoleranceRead */]: "Read AllergyIntolerance",
  ["group.security.allergyintolerance.create" /* AllergyIntoleranceCreate */]: "Create AllergyIntolerance",
  ["group.security.allergyintolerance.update" /* AllergyIntoleranceUpdate */]: "Update AllergyIntolerance",
  ["group.security.careteam.read" /* CareTeamRead */]: "Read CareTeam",
  ["group.security.careteam.create" /* CareTeamCreate */]: "Create CareTeam",
  ["group.security.careteam.update" /* CareTeamUpdate */]: "Update CareTeam",
  ["group.security.admin" /* Admin */]: "Admin tab access",
  ["group.security.careplan.read" /* CarePlanRead */]: "Read CarePlan",
  ["group.security.careplan.create" /* CarePlanCreate */]: "Create CarePlan",
  ["group.security.careplan.update" /* CarePlanUpdate */]: "Update CarePlan",
  ["group.security.plandefinition.read" /* PlanDefinitionRead */]: "Read PlanDefinition",
  ["group.security.plandefinition.create" /* PlanDefinitionCreate */]: "Create PlanDefinition",
  ["group.security.plandefinition.update" /* PlanDefinitionUpdate */]: "Update PlanDefinition",
  ["group.security.activitydefinition.read" /* ActivityDefinitionRead */]: "Read ActivityDefinition",
  ["group.security.activitydefinition.create" /* ActivityDefinitionCreate */]: "Create ActivityDefinition",
  ["group.security.activitydefinition.update" /* ActivityDefinitionUpdate */]: "Update ActivityDefinition",
  ["group.security.questionnaire.read" /* QuestionnaireRead */]: "Read Questionnaire",
  ["group.security.questionnaire.create" /* QuestionnaireCreate */]: "Create Questionnaire",
  ["group.security.questionnaire.update" /* QuestionnaireUpdate */]: "Update Questionnaire",
  ["group.security.questionnaireresponse.read" /* QuestionnaireResponseRead */]: "Read QuestionnaireResponse",
  ["group.security.questionnaireresponse.create" /* QuestionnaireResponseCreate */]: "Create QuestionnaireResponse",
  ["group.security.questionnaireresponse.update" /* QuestionnaireResponseUpdate */]: "Update QuestionnaireResponse",
  ["group.security.riskassessment.read" /* RiskAssessmentRead */]: "Read RiskAssessment",
  ["group.security.riskassessment.create" /* RiskAssessmentCreate */]: "Create RiskAssessment",
  ["group.security.riskassessment.update" /* RiskAssessmentUpdate */]: "Update RiskAssessment",
  ["group.security.flag.read" /* FlagRead */]: "Read Flag",
  ["group.security.flag.create" /* FlagCreate */]: "Create Flag",
  ["group.security.flag.update" /* FlagUpdate */]: "Update Flag"
};
var GroupCode = /* @__PURE__ */ ((GroupCode2) => {
  GroupCode2["PractitionerClinical"] = "group.code.practitioner.clinical";
  GroupCode2["PractitionerAdministration"] = "group.code.practitioner.administration";
  GroupCode2["PractitionerTechnical"] = "group.code.practitioner.technical";
  GroupCode2["PractitionerCareCoordinator"] = "group.code.practitioner.carecoordinator";
  return GroupCode2;
})(GroupCode || {});
var GroupCodeDescription = {
  ["group.code.practitioner.clinical" /* PractitionerClinical */]: "Clinical",
  ["group.code.practitioner.administration" /* PractitionerAdministration */]: "Administration",
  ["group.code.practitioner.technical" /* PractitionerTechnical */]: "Technical",
  ["group.code.practitioner.carecoordinator" /* PractitionerCareCoordinator */]: "Care Coordinator"
};

// src/coding/organization.ts
var OrganizationCode = /* @__PURE__ */ ((OrganizationCode2) => {
  OrganizationCode2["HealthcareProvider"] = "prov";
  OrganizationCode2["HospitalDepartment"] = "dept";
  OrganizationCode2["OrganizationalTeam"] = "team";
  OrganizationCode2["InsuranceCompany"] = "ins";
  OrganizationCode2["Other"] = "other";
  OrganizationCode2["PharmacyProvider"] = "pharmacy";
  return OrganizationCode2;
})(OrganizationCode || {});
var OrganizationCodeDescription = {
  ["prov" /* HealthcareProvider */]: "Healthcare Provider",
  ["dept" /* HospitalDepartment */]: "Hospital Department",
  ["team" /* OrganizationalTeam */]: "Organizational Team",
  ["ins" /* InsuranceCompany */]: "Insurance Company",
  ["other" /* Other */]: "Other",
  ["pharmacy" /* PharmacyProvider */]: "Pharmacy"
};

// src/coding/device.ts
var DeviceStatusReason = /* @__PURE__ */ ((DeviceStatusReason2) => {
  DeviceStatusReason2["online"] = "online";
  DeviceStatusReason2["paused"] = "paused";
  DeviceStatusReason2["standby"] = "standby";
  DeviceStatusReason2["offline"] = "offline";
  DeviceStatusReason2["notReady"] = "not-ready";
  DeviceStatusReason2["transducerDisconnected"] = "transduc-discon";
  DeviceStatusReason2["hardwareDisconnected"] = "hw-discon";
  DeviceStatusReason2["off"] = "off";
  return DeviceStatusReason2;
})(DeviceStatusReason || {});
var DeviceStatusReasonDescription = {
  ["online" /* online */]: "The device is online",
  ["paused" /* paused */]: "The device is paused",
  ["standby" /* standby */]: "The device is ready but not actively operating",
  ["offline" /* offline */]: "The device is offline",
  ["not-ready" /* notReady */]: "The device is not ready",
  ["transduc-discon" /* transducerDisconnected */]: "The device transducer is disconnected",
  ["hw-discon" /* hardwareDisconnected */]: "The device hardware is disconnected",
  ["off" /* off */]: "The device is off"
};
var DeviceCode = /* @__PURE__ */ ((DeviceCode2) => {
  DeviceCode2["relay"] = "device.relay";
  DeviceCode2["patch"] = "device.patch";
  DeviceCode2["band"] = "device.band";
  DeviceCode2["glucose"] = "device.glucose";
  DeviceCode2["bloodPressure"] = "device.bloodpressure";
  return DeviceCode2;
})(DeviceCode || {});

// src/coding/identifier.ts
var IdentifierCode = /* @__PURE__ */ ((IdentifierCode4) => {
  IdentifierCode4["encounterMedicalAidAuthorizationCode"] = "identifier.encounter.hospitalization.authorizationcode";
  IdentifierCode4["encounterMedicalAidAuthorizationDate"] = "identifier.encounter.hospitalization.authorizationdate";
  IdentifierCode4["encounterHospitalizationSchemeCode"] = "identifier.encounter.hospitalization.extension.schemecode";
  IdentifierCode4["encounterHospitalizationSubscriberId"] = "identifier.encounter.hospitalization.extension..subscriberid";
  IdentifierCode4["encounterHospitalizationDependentCode"] = "identifier.encounter.hospitalization.extension.dependent";
  IdentifierCode4["registrationNumber"] = "identifier.practitioner.registrationnumber";
  IdentifierCode4["ampathMnemonic"] = "identifier.practitioner.external.ampathMnemonic";
  IdentifierCode4["deviceType"] = "identifier.device.type";
  IdentifierCode4["serviceRequestPerformer"] = "identifier.servicerequest.performer";
  IdentifierCode4["southAfricanIdNumber"] = "identifier.southafricanidnumber";
  IdentifierCode4["namibianIdNumber"] = "identifier.namibianidnumber";
  IdentifierCode4["passportNumber"] = "identifier.passportnumber";
  IdentifierCode4["membershipNumber"] = "identifier.patient.coverage.subscriberid";
  IdentifierCode4["schemeCode"] = "identifier.patient.coverage.schemecode";
  IdentifierCode4["dependantCode"] = "identifier.patient.coverage.dependent";
  IdentifierCode4["organizationSchemeCode"] = "identifier.organization.type.insurance.schemeCode";
  IdentifierCode4["medicationRequestGroupIdentifier"] = "identifier.medicationrequest.groupidentifier";
  IdentifierCode4["medicationStatementGroupIdentifier"] = "identifier.medicationstatement.groupidentifier";
  IdentifierCode4["claimInvoiceNumber"] = "identifier.claim.invoicenumber";
  IdentifierCode4["chargeItemConsumableCode"] = "identifier.chargeitem.medprax.materialcode";
  IdentifierCode4["conversation"] = "identifier.communication.conversation";
  IdentifierCode4["conversationMessage"] = "identifier.communication.conversation.message";
  IdentifierCode4["locationCapacity"] = "identifier.location.capacity";
  IdentifierCode4["conversationMessageType"] = "identifier.communication.conversation.message.type";
  IdentifierCode4["conversationParticipant"] = "identifier.communication.conversation.participant";
  IdentifierCode4["conversationAlert"] = "identifier.communication.conversation.alert";
  IdentifierCode4["libraryTemplateId"] = "identifier.library.template.id";
  IdentifierCode4["carePlanActivityDate"] = "identifier.careplan.activity.scheduledPeriod";
  return IdentifierCode4;
})(IdentifierCode || {});

// src/coding/device-use-statement.ts
var DeviceUseStatementCode = /* @__PURE__ */ ((DeviceUseStatementCode2) => {
  DeviceUseStatementCode2["relay"] = "deviceusestatement.relay";
  DeviceUseStatementCode2["patch"] = "deviceusestatement.patch";
  DeviceUseStatementCode2["band"] = "deviceusestatement.band";
  DeviceUseStatementCode2["glucose"] = "deviceusestatement.glucose";
  DeviceUseStatementCode2["bloodPressure"] = "deviceusestatement.bloodPressure";
  return DeviceUseStatementCode2;
})(DeviceUseStatementCode || {});

// src/coding/observation.ts
var ObservationCode = /* @__PURE__ */ ((ObservationCode2) => {
  ObservationCode2["clinicalImpression"] = "observation.clinicalimpression";
  ObservationCode2["vitals"] = "observation.vitals";
  ObservationCode2["calibration"] = "observation.calibration";
  ObservationCode2["pregnancy"] = "observation.pregnancy";
  ObservationCode2["lactation"] = "observation.lactation";
  ObservationCode2["edd"] = "observation.expecteddeliverydate";
  ObservationCode2["pathologyTestResult"] = "observation.pathology.test.result";
  ObservationCode2["patchPosture"] = "observation.patch.posture";
  ObservationCode2["patchHeartRate"] = "observation.patch.heartrate";
  ObservationCode2["patchRespiratoryRate"] = "observation.patch.respatoryrate";
  ObservationCode2["patchSteps"] = "observation.patch.steps";
  ObservationCode2["patchCoreTemperature"] = "observation.patch.coretemperature";
  ObservationCode2["patchBattery"] = "observation.patch.battery";
  ObservationCode2["mightySatOxygenSaturation"] = "observation.relay.oxygensaturation";
  return ObservationCode2;
})(ObservationCode || {});
var ObservationCodeDescription = {
  ["observation.patch.posture" /* patchPosture */]: "Posture",
  ["observation.patch.heartrate" /* patchHeartRate */]: "Heart Rate",
  ["observation.patch.respatoryrate" /* patchRespiratoryRate */]: "Respiratory Rate",
  ["observation.patch.steps" /* patchSteps */]: "Steps",
  ["observation.patch.coretemperature" /* patchCoreTemperature */]: "Core Temperature",
  ["observation.patch.battery" /* patchBattery */]: "Patch Battery",
  ["observation.relay.oxygensaturation" /* mightySatOxygenSaturation */]: "Oxygen Saturation",
  ["observation.clinicalimpression" /* clinicalImpression */]: "Note",
  ["observation.vitals" /* vitals */]: "Vitals",
  ["observation.calibration" /* calibration */]: "Calibration",
  ["observation.pregnancy" /* pregnancy */]: "Pregnancy",
  ["observation.lactation" /* lactation */]: "Lactation",
  ["observation.expecteddeliverydate" /* edd */]: "Expected Delivery Date",
  ["observation.pathology.test.result" /* pathologyTestResult */]: "Pathology Test Result"
};
var ObservationMeasurementCode = /* @__PURE__ */ ((ObservationMeasurementCode2) => {
  ObservationMeasurementCode2["Activity"] = "observation.measurement.activity";
  ObservationMeasurementCode2["HeartRate"] = "observation.measurement.heartrate";
  ObservationMeasurementCode2["RespiratoryRate"] = "observation.measurement.respiratoryrate";
  ObservationMeasurementCode2["SkinTemperature"] = "observation.measurement.skintemperature";
  ObservationMeasurementCode2["CoreTemperature"] = "observation.measurement.coretemperature";
  ObservationMeasurementCode2["OxygenSaturation"] = "observation.measurement.oxygensaturation";
  ObservationMeasurementCode2["PerfusionIndex"] = "observation.measurement.perfusionindex";
  ObservationMeasurementCode2["Steps"] = "observation.measurement.steps";
  ObservationMeasurementCode2["Posture"] = "observation.measurement.posture";
  ObservationMeasurementCode2["Battery"] = "observation.measurement.battery";
  ObservationMeasurementCode2["RRI"] = "observation.measurement.rri";
  ObservationMeasurementCode2["ECG"] = "observation.measurement.ecg";
  ObservationMeasurementCode2["Glucose"] = "observation.measurement.glucose";
  ObservationMeasurementCode2["GlucoseBeforeMeal"] = "observation.measurement.glucosebeforemeal";
  ObservationMeasurementCode2["GlucoseAfterMeal"] = "observation.measurement.glucoseaftermeal";
  ObservationMeasurementCode2["GlucoseFasting"] = "observation.measurement.glucosefasting";
  ObservationMeasurementCode2["SystolicArterialBloodPressure"] = "observation.measurement.systolicarterialbloodpressure";
  ObservationMeasurementCode2["DiastolicArterialBloodPressure"] = "observation.measurement.diastolicarterialbloodpressure";
  ObservationMeasurementCode2["MeanArterialBloodPressure"] = "observation.measurement.meanarterialbloodpressure";
  ObservationMeasurementCode2["CombinedArterialBloodPressure"] = "observation.measurement.combinedarterialbloodpressure";
  ObservationMeasurementCode2["Weight"] = "observation.measurement.weight";
  ObservationMeasurementCode2["PostureCalibration"] = "observation.measurement.posturecalibration";
  ObservationMeasurementCode2["EarlyWarningScore"] = "observation.measurement.earlywarningscore";
  ObservationMeasurementCode2["ButtonPress"] = "observation.measurement.buttonpress";
  ObservationMeasurementCode2["SensorLowQuality"] = "observation.measurement.sensorlowquality";
  ObservationMeasurementCode2["Fall"] = "observation.measurement.fall";
  ObservationMeasurementCode2["WearStatus"] = "observation.measurement.wearstatus";
  ObservationMeasurementCode2["DeviceStatus"] = "observation.measurement.devicestatus";
  return ObservationMeasurementCode2;
})(ObservationMeasurementCode || {});
var ObservationMeasurementUnits = {
  ["observation.measurement.activity" /* Activity */]: void 0,
  ["observation.measurement.heartrate" /* HeartRate */]: "bpm",
  ["observation.measurement.respiratoryrate" /* RespiratoryRate */]: "bpm",
  ["observation.measurement.skintemperature" /* SkinTemperature */]: "\xB0C",
  ["observation.measurement.coretemperature" /* CoreTemperature */]: "\xB0C",
  ["observation.measurement.oxygensaturation" /* OxygenSaturation */]: "%",
  ["observation.measurement.perfusionindex" /* PerfusionIndex */]: void 0,
  ["observation.measurement.steps" /* Steps */]: void 0,
  ["observation.measurement.posture" /* Posture */]: void 0,
  ["observation.measurement.battery" /* Battery */]: "%",
  ["observation.measurement.rri" /* RRI */]: void 0,
  ["observation.measurement.ecg" /* ECG */]: void 0,
  ["observation.measurement.glucose" /* Glucose */]: "mmol/l",
  ["observation.measurement.glucosebeforemeal" /* GlucoseBeforeMeal */]: "mmol/l",
  ["observation.measurement.glucoseaftermeal" /* GlucoseAfterMeal */]: "mmol/l",
  ["observation.measurement.glucosefasting" /* GlucoseFasting */]: "mmol/l",
  ["observation.measurement.systolicarterialbloodpressure" /* SystolicArterialBloodPressure */]: "mm Hg",
  ["observation.measurement.diastolicarterialbloodpressure" /* DiastolicArterialBloodPressure */]: "mm Hg",
  ["observation.measurement.meanarterialbloodpressure" /* MeanArterialBloodPressure */]: "mm Hg",
  ["observation.measurement.combinedarterialbloodpressure" /* CombinedArterialBloodPressure */]: "mm Hg",
  ["observation.measurement.weight" /* Weight */]: "kg",
  ["observation.measurement.posturecalibration" /* PostureCalibration */]: void 0,
  ["observation.measurement.earlywarningscore" /* EarlyWarningScore */]: void 0,
  ["observation.measurement.buttonpress" /* ButtonPress */]: void 0,
  ["observation.measurement.sensorlowquality" /* SensorLowQuality */]: void 0,
  ["observation.measurement.fall" /* Fall */]: void 0,
  ["observation.measurement.wearstatus" /* WearStatus */]: void 0,
  ["observation.measurement.devicestatus" /* DeviceStatus */]: void 0
};

// src/coding/diagnostic-report.ts
var DiagnosticReportCode = /* @__PURE__ */ ((DiagnosticReportCode2) => {
  DiagnosticReportCode2["ampath"] = "diagnosticreport.pathology.ampath";
  DiagnosticReportCode2["lancet"] = "diagnosticreport.pathology.lancet";
  return DiagnosticReportCode2;
})(DiagnosticReportCode || {});
var DiagnosticReportIdentifier = /* @__PURE__ */ ((DiagnosticReportIdentifier3) => {
  DiagnosticReportIdentifier3["AmpathOrderNumber"] = "diagnosticreport.identifier.ampath.ordernumber";
  DiagnosticReportIdentifier3["LancetOrderNumber"] = "diagnosticreport.identifier.lancet.ordernumber";
  DiagnosticReportIdentifier3["LancetOrderId"] = "diagnosticreport.identifier.lancet.orderId";
  return DiagnosticReportIdentifier3;
})(DiagnosticReportIdentifier || {});

// src/coding/coverage.ts
var CoverageClassCode = /* @__PURE__ */ ((CoverageClassCode2) => {
  CoverageClassCode2["Group"] = "group";
  CoverageClassCode2["SubGroup"] = "subgroup";
  CoverageClassCode2["Plan"] = "plan";
  CoverageClassCode2["SubPlan"] = "subplan";
  CoverageClassCode2["Class"] = "class";
  CoverageClassCode2["SubClass"] = "subclass";
  CoverageClassCode2["Sequence"] = "sequence";
  CoverageClassCode2["PharmacyBusinessIdentificationNumber"] = "rxbin";
  CoverageClassCode2["PharmacyProcessControlNumber"] = "rxpcn";
  CoverageClassCode2["PharmacyMemberId"] = "rxid";
  CoverageClassCode2["PharmacyGroupNumber"] = "rxgroup";
  return CoverageClassCode2;
})(CoverageClassCode || {});
var CoverageClassDisplayMapping = {
  ["group" /* Group */]: "Group",
  ["subgroup" /* SubGroup */]: "SubGroup",
  ["plan" /* Plan */]: "Plan",
  ["subplan" /* SubPlan */]: "SubPlan",
  ["class" /* Class */]: "Class",
  ["subclass" /* SubClass */]: "SubClass",
  ["sequence" /* Sequence */]: "Sequence",
  ["rxbin" /* PharmacyBusinessIdentificationNumber */]: "Pharmacy Business Identification Number",
  ["rxpcn" /* PharmacyProcessControlNumber */]: "Pharmacy Process Control Number",
  ["rxid" /* PharmacyMemberId */]: "Pharmacy Member ID",
  ["rxgroup" /* PharmacyGroupNumber */]: "Pharmacy Group Number"
};

// src/coding/service-request.ts
var ServiceRequestCode = /* @__PURE__ */ ((ServiceRequestCode2) => {
  ServiceRequestCode2["PathologyRequest"] = "servicerequest.pathology.request";
  return ServiceRequestCode2;
})(ServiceRequestCode || {});
var ServiceRequestCodeDescription = {
  ["servicerequest.pathology.request" /* PathologyRequest */]: "Pathology Request"
};
var ServiceRequestPerformerIdentifier = /* @__PURE__ */ ((ServiceRequestPerformerIdentifier2) => {
  ServiceRequestPerformerIdentifier2["Ampath"] = "servicerequest.performer.ampath";
  ServiceRequestPerformerIdentifier2["Lancet"] = "servicerequest.performer.lancet";
  return ServiceRequestPerformerIdentifier2;
})(ServiceRequestPerformerIdentifier || {});
var ServiceRequestIdentifier = /* @__PURE__ */ ((ServiceRequestIdentifier3) => {
  ServiceRequestIdentifier3["AmpathOrderNumber"] = "servicerequest.identifier.ampath.ordernumber";
  ServiceRequestIdentifier3["LancetOrderNumber"] = "servicerequest.identifier.lancet.ordernumber";
  ServiceRequestIdentifier3["LancetOrderId"] = "servicerequest.identifier.lancet.orderid";
  return ServiceRequestIdentifier3;
})(ServiceRequestIdentifier || {});
var ServiceRequestPerformerDescription = {
  ["servicerequest.performer.ampath" /* Ampath */]: "Ampath",
  ["servicerequest.performer.lancet" /* Lancet */]: "Lancet"
};
var ServiceRequestType = /* @__PURE__ */ ((ServiceRequestType2) => {
  ServiceRequestType2["escalationRequest"] = "servicerequest.careplan.escalation";
  return ServiceRequestType2;
})(ServiceRequestType || {});

// src/coding/related-person.ts
var RelatedPersonRelationship = /* @__PURE__ */ ((RelatedPersonRelationship2) => {
  RelatedPersonRelationship2["NextOfKin"] = "relatedperson.relationship.nextofkin";
  RelatedPersonRelationship2["CoverageSubscriber"] = "relatedperson.relationship.coverage.subscriber";
  return RelatedPersonRelationship2;
})(RelatedPersonRelationship || {});

// src/coding/clinical-impression.ts
var ClinicalImpressionCode = /* @__PURE__ */ ((ClinicalImpressionCode2) => {
  ClinicalImpressionCode2["Routine"] = "clinicalimpression.code.routine";
  ClinicalImpressionCode2["ClinicalUpdate"] = "clinicalimpression.code.clinicalupdate";
  ClinicalImpressionCode2["Handover"] = "clinicalimpression.code.handover";
  ClinicalImpressionCode2["Onboarding"] = "clinicalimpression.code.onboarding";
  ClinicalImpressionCode2["Authorization"] = "clinicalimpression.code.authorization";
  ClinicalImpressionCode2["ClinicalCallout"] = "clinicalimpression.code.clinicalcallout";
  ClinicalImpressionCode2["Discharge"] = "clinicalimpression.code.discharge";
  ClinicalImpressionCode2["BloodResults"] = "clinicalimpression.code.bloodresults";
  ClinicalImpressionCode2["Physiotherapy"] = "clinicalimpression.code.physiotherapy";
  ClinicalImpressionCode2["DailySummary"] = "clinicalimpression.code.dailysummary";
  return ClinicalImpressionCode2;
})(ClinicalImpressionCode || {});
var ClinicalImpressionLocationCode = /* @__PURE__ */ ((ClinicalImpressionLocationCode2) => {
  ClinicalImpressionLocationCode2["Virtual"] = "clinicalimpression.code.location.virtual";
  ClinicalImpressionLocationCode2["InPerson"] = "clinicalimpression.code.location.inperson";
  return ClinicalImpressionLocationCode2;
})(ClinicalImpressionLocationCode || {});
var ClinicalImpressionNoteCode = /* @__PURE__ */ ((ClinicalImpressionNoteCode2) => {
  ClinicalImpressionNoteCode2["Subjective"] = "clinicalimpression.note.extension.code.soap.subjective";
  ClinicalImpressionNoteCode2["Objective"] = "clinicalimpression.note.extension.code.soap.objective";
  ClinicalImpressionNoteCode2["Plan"] = "clinicalimpression.note.extension.code.soap.plan";
  ClinicalImpressionNoteCode2["Assessment"] = "clinicalimpression.note.extension.code.soap.assessment";
  return ClinicalImpressionNoteCode2;
})(ClinicalImpressionNoteCode || {});
var ClinicalImpressionAssessmentValueCode = /* @__PURE__ */ ((ClinicalImpressionAssessmentValueCode2) => {
  ClinicalImpressionAssessmentValueCode2["Stable"] = "clinicalimpression.code.soap.assessment.stable";
  ClinicalImpressionAssessmentValueCode2["Deteriorating"] = "clinicalimpression.code.soap.assessment.deteriorating";
  ClinicalImpressionAssessmentValueCode2["Improving"] = "clinicalimpression.code.soap.assessment.improving";
  ClinicalImpressionAssessmentValueCode2["Demised"] = "clinicalimpression.code.soap.assessment.demised";
  return ClinicalImpressionAssessmentValueCode2;
})(ClinicalImpressionAssessmentValueCode || {});
var clinicalImpressionAssessmentValueCodeDisplay = {
  ["clinicalimpression.code.soap.assessment.stable" /* Stable */]: "Stable",
  ["clinicalimpression.code.soap.assessment.deteriorating" /* Deteriorating */]: "Deteriorating",
  ["clinicalimpression.code.soap.assessment.improving" /* Improving */]: "Improving",
  ["clinicalimpression.code.soap.assessment.demised" /* Demised */]: "Demised"
};
var ClinicalImpressionPlanValueCode = /* @__PURE__ */ ((ClinicalImpressionPlanValueCode2) => {
  ClinicalImpressionPlanValueCode2["Continue"] = "clinicalimpression.code.soap.plan.continue";
  ClinicalImpressionPlanValueCode2["Amend"] = "clinicalimpression.code.soap.plan.amend";
  ClinicalImpressionPlanValueCode2["Discharge"] = "clinicalimpression.code.soap.plan.discharge";
  ClinicalImpressionPlanValueCode2["Escalate"] = "clinicalimpression.code.soap.plan.escalate";
  ClinicalImpressionPlanValueCode2["UpgradedToHAH"] = "clinicalimpression.code.soap.plan.upgradedToHAH";
  return ClinicalImpressionPlanValueCode2;
})(ClinicalImpressionPlanValueCode || {});
var clinicalImpressionPlanValueCodeDisplay = {
  ["clinicalimpression.code.soap.plan.continue" /* Continue */]: "Continue",
  ["clinicalimpression.code.soap.plan.amend" /* Amend */]: "Amend",
  ["clinicalimpression.code.soap.plan.discharge" /* Discharge */]: "Discharge",
  ["clinicalimpression.code.soap.plan.escalate" /* Escalate */]: "Escalate",
  ["clinicalimpression.code.soap.plan.upgradedToHAH" /* UpgradedToHAH */]: "Upgraded to hospital at home"
};
var ClinicalImpressionInvestigationCode = /* @__PURE__ */ ((ClinicalImpressionInvestigationCode2) => {
  ClinicalImpressionInvestigationCode2["LatestVitals"] = "clinicalimpression.investigation.code.latestvitals";
  ClinicalImpressionInvestigationCode2["Media"] = "clinicalimpression.investigation.code.media";
  return ClinicalImpressionInvestigationCode2;
})(ClinicalImpressionInvestigationCode || {});

// src/coding/human-name.ts
var HumanNamePrefix = /* @__PURE__ */ ((HumanNamePrefix2) => {
  HumanNamePrefix2["mr"] = "Mr.";
  HumanNamePrefix2["mrs"] = "Mrs.";
  HumanNamePrefix2["miss"] = "Miss";
  HumanNamePrefix2["prof"] = "Prof.";
  HumanNamePrefix2["dr"] = "Dr.";
  HumanNamePrefix2["sr"] = "Sr.";
  return HumanNamePrefix2;
})(HumanNamePrefix || {});

// src/coding/patient.ts
var PatientStatusCode = /* @__PURE__ */ ((PatientStatusCode2) => {
  PatientStatusCode2["Admitted"] = "patient.status.admitted";
  PatientStatusCode2["Onboarded"] = "patient.status.onboarded";
  PatientStatusCode2["Discharged"] = "patient.status.discharged";
  PatientStatusCode2["Invalidated"] = "patient.status.invalidated";
  return PatientStatusCode2;
})(PatientStatusCode || {});

// src/coding/quantity.ts
var QuantityCode = /* @__PURE__ */ ((QuantityCode2) => {
  QuantityCode2["OxygenRate"] = "quantity.code.oxygenrate";
  QuantityCode2["ChargeItemConsumable"] = "quantity.chargeitem.consumable";
  return QuantityCode2;
})(QuantityCode || {});

// src/coding/address.ts
var CountryCode = /* @__PURE__ */ ((CountryCode2) => {
  CountryCode2["SouthAfrica"] = "ZA";
  CountryCode2["Namibia"] = "NA";
  return CountryCode2;
})(CountryCode || {});

// src/coding/device-metric.ts
var DeviceMetricTypeCode = /* @__PURE__ */ ((DeviceMetricTypeCode2) => {
  DeviceMetricTypeCode2["patchCalibration"] = "devicemetric.calibration.patch";
  return DeviceMetricTypeCode2;
})(DeviceMetricTypeCode || {});

// src/coding/charge-item-definition.ts
var ChargeItemDefinitionCode = /* @__PURE__ */ ((ChargeItemDefinitionCode2) => {
  ChargeItemDefinitionCode2["ClaimLine"] = "chargeitemdefinition.code.type.claimline";
  return ChargeItemDefinitionCode2;
})(ChargeItemDefinitionCode || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["ZAR"] = "ZAR";
  return Currency2;
})(Currency || {});
var CHARGE_ITEM_DEFINITION_APPLICABILITY_LANGUAGE = "text/quro-charge-item-definition";

// src/coding/claim-response.ts
var ClaimResponseTypeCode = /* @__PURE__ */ ((ClaimResponseTypeCode2) => {
  ClaimResponseTypeCode2["HospitalAtHome"] = "claimresponse.type.hospitalathome";
  ClaimResponseTypeCode2["TCP"] = "claimresponse.type.tcp";
  ClaimResponseTypeCode2["RemotePatientMonitoring"] = "claimresponse.type.remotepatientmonitoring";
  ClaimResponseTypeCode2["HealingHands"] = "claimresponse.type.healinghands";
  ClaimResponseTypeCode2["Arthroplasty"] = "claimresponse.type.arthroplasty";
  ClaimResponseTypeCode2["InHospitalMonitoring"] = "claimresponse.type.inhospitalmonitoring";
  ClaimResponseTypeCode2["Lace"] = "claimresponse.type.lace";
  ClaimResponseTypeCode2["HospitalAtHomeUpgrade"] = "claimresponse.type.hospitalathome.upgrade";
  ClaimResponseTypeCode2["SPHERE"] = "claimresponse.type.sphere";
  return ClaimResponseTypeCode2;
})(ClaimResponseTypeCode || {});
var ClaimResponseTotalCategory = /* @__PURE__ */ ((ClaimResponseTotalCategory2) => {
  ClaimResponseTotalCategory2["TotalClaimedAmount"] = "claimresponse.total.category.totalclaimedamount";
  ClaimResponseTotalCategory2["TotalPaidProviderAmount"] = "claimresponse.total.category.totalpaidprovideramount";
  ClaimResponseTotalCategory2["BalanceOutstandingAmount"] = "claimresponse.total.category.balanceoutstandingamount";
  return ClaimResponseTotalCategory2;
})(ClaimResponseTotalCategory || {});
var ClaimResponseItemAdjudicationCategory = /* @__PURE__ */ ((ClaimResponseItemAdjudicationCategory2) => {
  ClaimResponseItemAdjudicationCategory2["BilledAmount"] = "claimresponse.item.adjudication.category.billedamount";
  ClaimResponseItemAdjudicationCategory2["MedicalAidPayable"] = "claimresponse.item.adjudication.category.medicalaidpayable";
  ClaimResponseItemAdjudicationCategory2["MedicalAidRate"] = "claimresponse.item.adjudication.category.medicalaidrate";
  return ClaimResponseItemAdjudicationCategory2;
})(ClaimResponseItemAdjudicationCategory || {});

// src/coding/task.ts
var TaskCode = /* @__PURE__ */ ((TaskCode2) => {
  TaskCode2["ClinicalImpressionFollowUp"] = "task.code.clinicalimpression.followup";
  TaskCode2["ClinicalImpressionReview"] = "task.code.clinicalimpression.review";
  TaskCode2["ServiceRequestCreate"] = "task.code.servicerequest.create";
  TaskCode2["DiagnosticReportFollowUp"] = "task.code.diagnosticreport.followup";
  TaskCode2["MedicationRequestCreate"] = "task.code.medicationrequest.create";
  TaskCode2["MedicationRequestFollowUp"] = "task.code.medicationrequest.followup";
  TaskCode2["MediaFollowUp"] = "task.code.media.followup";
  TaskCode2["OtherSchedule"] = "task.code.other.schedule";
  TaskCode2["OtherContact"] = "task.code.other.contact";
  TaskCode2["OtherHomeVisit"] = "task.code.other.homevisit";
  TaskCode2["OtherClinicalCallOut"] = "task.code.other.clinicalcallout";
  return TaskCode2;
})(TaskCode || {});
var TaskReferenceType = /* @__PURE__ */ ((TaskReferenceType2) => {
  TaskReferenceType2["ClinicalImpression"] = "task.reference.type.clinicalimpression";
  TaskReferenceType2["ServiceRequest"] = "task.reference.type.servicerequest";
  TaskReferenceType2["DiagnosticReport"] = "task.reference.type.diagnosticreport";
  TaskReferenceType2["MedicationRequest"] = "task.reference.type.medicationrequest";
  TaskReferenceType2["Media"] = "task.reference.type.media";
  return TaskReferenceType2;
})(TaskReferenceType || {});

// src/coding/medication-request.ts
var MedicationRequestDosageInstructionAdministrationCode = /* @__PURE__ */ ((MedicationRequestDosageInstructionAdministrationCode2) => {
  MedicationRequestDosageInstructionAdministrationCode2["Oral"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.oral";
  MedicationRequestDosageInstructionAdministrationCode2["Sublingual"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.sublingual";
  MedicationRequestDosageInstructionAdministrationCode2["Buccal"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.buccal";
  MedicationRequestDosageInstructionAdministrationCode2["Rectal"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.rectal";
  MedicationRequestDosageInstructionAdministrationCode2["Intravenous"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.intravenous";
  MedicationRequestDosageInstructionAdministrationCode2["Intramuscular"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.intramuscular";
  MedicationRequestDosageInstructionAdministrationCode2["Subcutaneous"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.subcutaneous";
  MedicationRequestDosageInstructionAdministrationCode2["Intranasal"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.intranasal";
  MedicationRequestDosageInstructionAdministrationCode2["Inhalation"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.inhalation";
  MedicationRequestDosageInstructionAdministrationCode2["Vaginal"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.vaginal";
  MedicationRequestDosageInstructionAdministrationCode2["Transdermal"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.transdermal";
  MedicationRequestDosageInstructionAdministrationCode2["Topical"] = "medicationrequest.dosageinstruction.additionalinstruction.administration.topical";
  return MedicationRequestDosageInstructionAdministrationCode2;
})(MedicationRequestDosageInstructionAdministrationCode || {});
var MedicationType = /* @__PURE__ */ ((MedicationType2) => {
  MedicationType2["acute"] = "medication.type.acute";
  MedicationType2["chronic"] = "medication.type.chronic";
  return MedicationType2;
})(MedicationType || {});
var MedicationTypeValue = {
  "medication.type.acute": "medication.type.acute" /* acute */,
  "medication.type.chronic": "medication.type.chronic" /* chronic */
};
var MedicationTypeDisplay = {
  ["medication.type.acute" /* acute */]: "Acute",
  ["medication.type.chronic" /* chronic */]: "Chronic"
};

// src/coding/condition.ts
var DiagnosisTypeCode = /* @__PURE__ */ ((DiagnosisTypeCode2) => {
  DiagnosisTypeCode2["rfa"] = "diagnosis.rfa";
  DiagnosisTypeCode2["chronic"] = "diagnosis.rfa.icd10code.chronic";
  DiagnosisTypeCode2["acute"] = "diagnosis.acute.icd10code";
  DiagnosisTypeCode2["primary"] = "diagnosis.authorization.icd10code.primary";
  DiagnosisTypeCode2["secondary"] = "diagnosis.authorization.icd10code.secondary";
  return DiagnosisTypeCode2;
})(DiagnosisTypeCode || {});
var DiagnosisStatusCode = /* @__PURE__ */ ((DiagnosisStatusCode2) => {
  DiagnosisStatusCode2["active"] = "active";
  DiagnosisStatusCode2["inactive"] = "inactive";
  return DiagnosisStatusCode2;
})(DiagnosisStatusCode || {});

// src/coding/location.ts
var LocationTypeCode = /* @__PURE__ */ ((LocationTypeCode2) => {
  LocationTypeCode2["VirtualWard"] = "location.type.virtualward";
  LocationTypeCode2["VirtualHospital"] = "location.type.virtualhospital";
  return LocationTypeCode2;
})(LocationTypeCode || {});
var LocationCodeDescription = {
  ["location.type.virtualhospital" /* VirtualHospital */]: "Virtual Hospital",
  ["location.type.virtualward" /* VirtualWard */]: "Virtual Ward"
};
var LocationAcuityCode = /* @__PURE__ */ ((LocationAcuityCode2) => {
  LocationAcuityCode2["Intensive"] = "location.acuity.intensive";
  LocationAcuityCode2["Medium"] = "location.acuity.medium";
  LocationAcuityCode2["Low"] = "location.acuity.low";
  return LocationAcuityCode2;
})(LocationAcuityCode || {});
var LocationAcuityDescription = {
  ["location.acuity.intensive" /* Intensive */]: "Intensive Monitoring Ward",
  ["location.acuity.medium" /* Medium */]: "Medium Monitoring Ward",
  ["location.acuity.low" /* Low */]: "Low Monitoring Ward"
};

// src/coding/care-team.ts
var CareTeamRoleCode = /* @__PURE__ */ ((CareTeamRoleCode2) => {
  CareTeamRoleCode2["intern"] = "careteam.general.intern";
  CareTeamRoleCode2["nurse"] = "careteam.quromedical.nurse";
  CareTeamRoleCode2["student"] = "careteam.general.student";
  CareTeamRoleCode2["doctor"] = "careteam.quromedical.doctor";
  CareTeamRoleCode2["registrar"] = "careteam.general.registrars";
  CareTeamRoleCode2["consultant"] = "careteam.general.consultant";
  CareTeamRoleCode2["medicalOfficer"] = "careteam.general.medicalOfficer";
  CareTeamRoleCode2["clinicalAssociate"] = "careteam.quromedical.clinicalAssociate";
  CareTeamRoleCode2["leadClinicalAssociate"] = "careteam.quromedical.leadClinicalAssociate";
  CareTeamRoleCode2["communityServiceMedicalOfficer"] = "careteam.general.communityServiceMedicalOfficer";
  return CareTeamRoleCode2;
})(CareTeamRoleCode || {});
var CareTeamRoleDescription = {
  ["careteam.quromedical.nurse" /* nurse */]: "Nurse",
  ["careteam.quromedical.doctor" /* doctor */]: "Doctor",
  ["careteam.general.intern" /* intern */]: "Intern",
  ["careteam.general.student" /* student */]: "Student",
  ["careteam.general.registrars" /* registrar */]: "Registrars",
  ["careteam.general.consultant" /* consultant */]: "Consultant",
  ["careteam.general.medicalOfficer" /* medicalOfficer */]: "Medical Officer",
  ["careteam.quromedical.clinicalAssociate" /* clinicalAssociate */]: "Clinical Associate",
  ["careteam.quromedical.leadClinicalAssociate" /* leadClinicalAssociate */]: "Lead Clinical Associate",
  ["careteam.general.communityServiceMedicalOfficer" /* communityServiceMedicalOfficer */]: "Community Service Medical Officer"
};
var CareTeamTypeCode = /* @__PURE__ */ ((CareTeamTypeCode2) => {
  CareTeamTypeCode2["careCoordinationTeam"] = "careteam.general.careCoordinationTeam";
  CareTeamTypeCode2["careTeam"] = "careteam.general.careTeam";
  return CareTeamTypeCode2;
})(CareTeamTypeCode || {});
var CareTeamTypeDescription = {
  ["careteam.general.careCoordinationTeam" /* careCoordinationTeam */]: "Care Coordination Team",
  ["careteam.general.careTeam" /* careTeam */]: "Care Team"
};

// src/coding/system.ts
var system = "https://quromedical.co.za";
var medpraxSystem = "https://www.medpraxapi.co.za";
var ampathSystem = "https://www.ampath.co.za";
var lancetSystem = "https://www.lancet.co.za";
var droppaSystem = "https://droppergroup.co.za";
var loincSystem = "http://loinc.org";
var fhirObservationInterpretationSystem = "http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation";
var twilioSystem = "https://www.twilio.com/";
var iconoirSystem = "https://iconoir.com";
var carboneSystem = "https://carbone.io";
var googleGemini2 = "https://cloud.google.com/vertex-ai/generative-ai/docs/gemini-v2#2.0-flash";

// src/coding/migration.ts
var MigrationCode = /* @__PURE__ */ ((MigrationCode3) => {
  MigrationCode3["Conversation"] = "migration.conversation";
  return MigrationCode3;
})(MigrationCode || {});

// src/coding/communication.ts
var CommunicationAlertCode = /* @__PURE__ */ ((CommunicationAlertCode2) => {
  CommunicationAlertCode2["unread"] = "communication.alert.urgent.unread";
  return CommunicationAlertCode2;
})(CommunicationAlertCode || {});

// src/coding/template.ts
var TemplateTypeCode = /* @__PURE__ */ ((TemplateTypeCode2) => {
  TemplateTypeCode2["CreateScript"] = "template.type.document.create-script";
  TemplateTypeCode2["TextMessage"] = "template.type.conversation.text-message";
  TemplateTypeCode2["ClinicalReferral"] = "template.type.document.clinical-referral";
  TemplateTypeCode2["HomeBasedCareReferral"] = "template.type.document.home-based-care-referral";
  TemplateTypeCode2["MotivationMedicalDevice"] = "template.type.document.motivation-medical-device";
  return TemplateTypeCode2;
})(TemplateTypeCode || {});

// src/coding/care-plan.ts
var CarePlanActivityCode = /* @__PURE__ */ ((CarePlanActivityCode2) => {
  CarePlanActivityCode2["Introduction"] = "careplan.activity.code.introduction";
  CarePlanActivityCode2["HospitalQuestionnaire"] = "careplan.activity.code.hospitalquestionnaire";
  CarePlanActivityCode2["MDTAppointments"] = "careplan.activity.code.mdtappointments";
  CarePlanActivityCode2["SymptomsEnquiry"] = "careplan.activity.code.symptomsenquiry";
  CarePlanActivityCode2["InterProfessionalServices"] = "careplan.activity.code.interprofessionalservices";
  CarePlanActivityCode2["IndividualAssessment"] = "careplan.activity.code.individualassessment";
  CarePlanActivityCode2["ContextualAssessment"] = "careplan.activity.code.contextualassessment";
  CarePlanActivityCode2["Comments"] = "careplan.activity.code.comments";
  CarePlanActivityCode2["Flag"] = "careplan.activity.code.flag";
  CarePlanActivityCode2["OnboardingReview"] = "careplan.activity.code.onboardingreview";
  CarePlanActivityCode2["QualityQuestionnaire"] = "careplan.activity.code.qualityquestionnaire";
  CarePlanActivityCode2["FollowUp"] = "careplan.activity.code.followup";
  CarePlanActivityCode2["DailyReview"] = "careplan.activity.code.dailyreview";
  CarePlanActivityCode2["Escalation"] = "careplan.activity.code.escalation";
  return CarePlanActivityCode2;
})(CarePlanActivityCode || {});
var CarePlanActivityCodeDisplay = {
  ["careplan.activity.code.introduction" /* Introduction */]: "Care Plan Introduction",
  ["careplan.activity.code.hospitalquestionnaire" /* HospitalQuestionnaire */]: "Hospital Questionnaire",
  ["careplan.activity.code.mdtappointments" /* MDTAppointments */]: "MDT Appointments",
  ["careplan.activity.code.symptomsenquiry" /* SymptomsEnquiry */]: "Symptoms Enquiry",
  ["careplan.activity.code.interprofessionalservices" /* InterProfessionalServices */]: "Inter Professional Services",
  ["careplan.activity.code.individualassessment" /* IndividualAssessment */]: "Individual Assessment",
  ["careplan.activity.code.contextualassessment" /* ContextualAssessment */]: "Contextual Assessment",
  ["careplan.activity.code.comments" /* Comments */]: "Comments",
  ["careplan.activity.code.flag" /* Flag */]: "Flag",
  ["careplan.activity.code.onboardingreview" /* OnboardingReview */]: "Onboarding Review",
  ["careplan.activity.code.qualityquestionnaire" /* QualityQuestionnaire */]: "Quality Questionnaire",
  ["careplan.activity.code.followup" /* FollowUp */]: "Follow Up",
  ["careplan.activity.code.dailyreview" /* DailyReview */]: "Daily Review",
  ["careplan.activity.code.escalation" /* Escalation */]: "Escalation"
};

// src/coding/risk-assessment.ts
var RiskAssessmentTypeCode = /* @__PURE__ */ ((RiskAssessmentTypeCode2) => {
  RiskAssessmentTypeCode2["IncompleteActivity"] = "riskassessment.type.incompleteactivity";
  RiskAssessmentTypeCode2["SchedueledAppointment"] = "riskassessment.type.schedueledappointment";
  return RiskAssessmentTypeCode2;
})(RiskAssessmentTypeCode || {});
var RiskAssessmentTypeCodeDescription = {
  ["riskassessment.type.incompleteactivity" /* IncompleteActivity */]: "Incomplete Activity",
  ["riskassessment.type.schedueledappointment" /* SchedueledAppointment */]: "Scheduled Appointment"
};

// src/coding/flag.ts
var FlagCode = /* @__PURE__ */ ((FlagCode2) => {
  FlagCode2["clinical"] = "flag.code.clinical";
  return FlagCode2;
})(FlagCode || {});

// src/coding/questionnaire.ts
var QuestionnaireActionCode = /* @__PURE__ */ ((QuestionnaireActionCode2) => {
  QuestionnaireActionCode2["ServiceRequestCreate"] = "questionnaire.action.servicerequest.create";
  QuestionnaireActionCode2["AppointmentCreate"] = "questionnaire.action.appointment.create";
  QuestionnaireActionCode2["TaskCreate"] = "questionnaire.action.task.create";
  return QuestionnaireActionCode2;
})(QuestionnaireActionCode || {});

// src/coding/language.ts
var LanguagePreference = /* @__PURE__ */ ((LanguagePreference2) => {
  LanguagePreference2["English"] = "person.language.preference.english";
  LanguagePreference2["Afrikaans"] = "person.language.preference.afrikaans";
  LanguagePreference2["Zulu"] = "person.language.preference.zulu";
  LanguagePreference2["Pedi"] = "person.language.preference.pedi";
  LanguagePreference2["Tswana"] = "person.language.preference.tswana";
  LanguagePreference2["Xhosa"] = "person.language.preference.xhosa";
  LanguagePreference2["Tsonga"] = "person.language.preference.tsonga";
  LanguagePreference2["Venda"] = "person.language.preference.venda";
  LanguagePreference2["Swati"] = "person.language.preference.swati";
  LanguagePreference2["Ndebele"] = "person.language.preference.ndebele";
  LanguagePreference2["Sotho"] = "person.language.preference.sotho";
  return LanguagePreference2;
})(LanguagePreference || {});
var LanguagePreferenceDisplay = {
  ["person.language.preference.english" /* English */]: "English",
  ["person.language.preference.afrikaans" /* Afrikaans */]: "Afrikaans",
  ["person.language.preference.zulu" /* Zulu */]: "Zulu",
  ["person.language.preference.pedi" /* Pedi */]: "Pedi",
  ["person.language.preference.tswana" /* Tswana */]: "Tswana",
  ["person.language.preference.xhosa" /* Xhosa */]: "Xhosa",
  ["person.language.preference.tsonga" /* Tsonga */]: "Tsonga",
  ["person.language.preference.venda" /* Venda */]: "Venda",
  ["person.language.preference.swati" /* Swati */]: "Swati",
  ["person.language.preference.ndebele" /* Ndebele */]: "Ndebele",
  ["person.language.preference.sotho" /* Sotho */]: "Sotho"
};

// src/coding/document.ts
var DocumentTypeCode = /* @__PURE__ */ ((DocumentTypeCode2) => {
  DocumentTypeCode2["clinicalReferral"] = "document.type.clinical-referral";
  DocumentTypeCode2["homeBasedCareReferral"] = "document.type.home-based-care-referral";
  DocumentTypeCode2["motivationMedicalDevice"] = "document.type.motivation-medical-device";
  DocumentTypeCode2["createScript"] = "document.type.create-script";
  return DocumentTypeCode2;
})(DocumentTypeCode || {});
var DocumentTypeCodeDescription = {
  ["document.type.clinical-referral" /* clinicalReferral */]: "Clinical referral",
  ["document.type.home-based-care-referral" /* homeBasedCareReferral */]: "Home-based care referral",
  ["document.type.motivation-medical-device" /* motivationMedicalDevice */]: "Motivation for medical device",
  ["document.type.create-script" /* createScript */]: "Create medication script"
};
var DocumentTypeToTemplateType = {
  ["document.type.clinical-referral" /* clinicalReferral */]: "template.type.document.clinical-referral" /* ClinicalReferral */,
  ["document.type.home-based-care-referral" /* homeBasedCareReferral */]: "template.type.document.home-based-care-referral" /* HomeBasedCareReferral */,
  ["document.type.motivation-medical-device" /* motivationMedicalDevice */]: "template.type.document.motivation-medical-device" /* MotivationMedicalDevice */,
  ["document.type.create-script" /* createScript */]: "template.type.document.create-script" /* CreateScript */
};

// src/mapping/bundle.ts
import { join as join2, partial } from "@quromedical/utils";

// src/mapping/id.ts
import { compact as compact2, difference, intersection, join } from "@quromedical/utils";
var getReferenceData = (resourceReference) => {
  const reference = resourceReference?.reference;
  if (!reference) {
    return void 0;
  }
  const [resource, id] = reference.split("/");
  const resourceType = resource;
  if (!resourceType || !id) {
    return void 0;
  }
  return {
    resourceType,
    id
  };
};
var allDefined = (parts) => compact2(parts).length === parts.length;
var isVersionReference = (resourceReference) => {
  const reference = resourceReference?.reference;
  if (!reference) {
    return false;
  }
  const parts = reference.split("/");
  const isRequiredLength = parts.length === 4;
  const isAllDefined = allDefined(parts);
  const hasHistory = parts[2] === "_history";
  return isRequiredLength && isAllDefined && hasHistory;
};
var getVersionReferenceData = (resourceReference) => {
  const [resourceType, id, _history, version] = resourceReference.reference.split(
    "/"
  );
  return {
    resourceType,
    id,
    version
  };
};
var createVersionReference = (resourceType, params) => ({
  reference: `${resourceType}/${params.id}/_history/${params.version}`,
  display: params.display
});
var getReferenceId = (reference) => {
  const referenceData = getReferenceData(reference);
  return referenceData?.id;
};
var getCreateReferenceId = (reference) => {
  const referenceData = getReferenceData(reference);
  return referenceData?.id;
};
var isValidReference = (reference) => !!reference?.reference;
var getReferenceType = (reference) => {
  const referenceData = getReferenceData(reference);
  return referenceData?.resourceType;
};
var getResourceId = (resource) => {
  const id = resource?.id;
  return id;
};
var getDisplay = (displayText) => {
  if (!displayText) {
    return void 0;
  }
  if (typeof displayText === "string") {
    return displayText;
  }
  const { name, email } = displayText;
  return `${name} <${email}>`;
};
var createReference = (resourceType, id, displayText) => {
  const display = getDisplay(displayText);
  return {
    id,
    reference: join([resourceType, id], "/"),
    display
  };
};
var createReferenceFromResource = (resource, displayText) => createReference(resource.resourceType, resource.id, displayText);
var createVersionReferenceFromResource = (resource, display) => {
  const version = resource.meta?.versionId;
  if (!version) {
    return void 0;
  }
  return createVersionReference(resource.resourceType, {
    id: resource.id,
    version,
    display
  });
};
var createUrlReference = (url) => ({
  reference: url
});
var generateBundleReferenceId = (resourceType, key) => join(["urn", resourceType, key], ":");
var attachBundleFullUrl = (entry, key) => {
  const fullUrl = generateBundleReferenceId(entry.resource.resourceType, key);
  return {
    ...entry,
    fullUrl
  };
};
var createReferenceFromBundleEntry = (entry) => ({
  reference: entry.fullUrl
});
var createBundleReference = (resourceType, id) => {
  const reference = generateBundleReferenceId(resourceType, id);
  return {
    reference
  };
};
var getIdQueryString = (ids) => {
  const filtered = compact2(ids);
  if (!filtered.length) {
    return void 0;
  }
  return join(filtered, ",");
};
var hasId = (resource) => !!resource.id;
var isResourceType = (resourceType) => (resource) => resource.resourceType === resourceType;
var getCommon = (ids, comparer) => {
  const compactIds = compact2(ids);
  if (!ids) {
    return [];
  }
  const commonIds = intersection(compactIds, comparer);
  return compact2(commonIds);
};
var omitCommon = (ids, subtractIds) => {
  const compactIds = compact2(ids);
  if (!ids) {
    return [];
  }
  const differenceIds = difference(compactIds, subtractIds || []);
  return compact2(differenceIds);
};
var getDiff = (newIds = [], oldIds = []) => {
  const added = omitCommon(newIds, oldIds);
  const removed = omitCommon(oldIds, newIds);
  const hasChanged = !!(added.length || removed.length);
  return {
    added,
    removed,
    hasChanged
  };
};
var createMapWithId = (mapper) => (input) => {
  const withoutId = mapper(input);
  return {
    ...withoutId,
    id: input.id
  };
};
var getReferenceIdFullUrl = (resourceReference) => {
  const reference = resourceReference?.reference;
  if (!reference) {
    return void 0;
  }
  return reference.split(":").pop();
};
var getResolvedReferenceId = (reference) => {
  return getReferenceId(reference) ? getReferenceId(reference) : getReferenceIdFullUrl(reference);
};

// src/mapping/bundle.ts
var isSuccessStatusCode = (status) => {
  if (!status) {
    return false;
  }
  const is200 = status.startsWith("200");
  const is201 = status.startsWith("201");
  return is200 || is201;
};
var isOperationSuccessful = (bundle) => {
  if (!bundle.entry) {
    return false;
  }
  const operationResults = bundle.entry.map((e) => e?.response);
  const unsuccessfulResults = operationResults.filter(
    (r) => !isSuccessStatusCode(r?.status)
  );
  return !unsuccessfulResults.length;
};
var createBundleMethodRequest = (method, resourceType, resourceId) => {
  const url = resourceId ? join2([resourceType, resourceId], "/") : resourceType;
  return {
    url,
    method
  };
};
var appendRequestToEntry = (method, bundleEntry, fullUrl) => {
  const resourceId = getResourceId(bundleEntry.resource);
  const request = createBundleMethodRequest(method, bundleEntry.resource.resourceType, resourceId);
  return {
    ...bundleEntry,
    request,
    fullUrl
  };
};
var mapResourceToEntry = (resource) => ({
  resource
});
var appendPostRequestToEntry = partial(appendRequestToEntry, "POST");
var appendPutRequestToEntry = partial(appendRequestToEntry, "PUT");
var getResourcesFromBundle = (bundle) => {
  if (!bundle?.entry) {
    return [];
  }
  const resources = bundle.entry.map((e) => e.resource);
  return resources;
};
var createBundle = (entry) => ({
  resourceType: "Bundle",
  type: "transaction",
  entry
});
var createBundleEntry = (entryMethod, resource, fullUrl) => appendRequestToEntry(entryMethod, mapResourceToEntry(resource), fullUrl);
var mapResourceToBundleEntry = (entryMethod, fullUrl) => (resource) => createBundleEntry(entryMethod, resource, fullUrl);

// src/mapping/auditEvent.ts
var createAuditEvent = (props) => {
  const { event, when, editor, toWhatResource, toWhatId, isFullUrl } = props;
  const byWhat = createReferenceFromResource(editor);
  const toWhat = isFullUrl ? createUrlReference(toWhatId) : createReference(toWhatResource, toWhatId);
  const recorded = when instanceof Date ? when.toISOString() : when;
  const auditEvent = {
    resourceType: "AuditEvent",
    recorded,
    type: {
      system,
      code: event
    },
    agent: [
      {
        requestor: false,
        who: byWhat
      }
    ],
    source: {
      observer: {
        identifier: {
          // this is the source of the event, the identifier is used for aggregating and analysis
          value: "quro-app"
        }
      }
    },
    entity: [
      {
        what: toWhat
      }
    ]
  };
  return auditEvent;
};
var createAuditBundle = (resources, editor, eventCode, entryMethod = "POST") => {
  const resourceEntries = resources.map(mapResourceToBundleEntry(entryMethod)).map(attachBundleFullUrl);
  const auditEntries = resourceEntries.map((o) => {
    const auditEvent = createAuditEvent({
      event: eventCode,
      toWhatId: o.resource.id || o.fullUrl,
      toWhatResource: o.resource.resourceType,
      when: /* @__PURE__ */ new Date(),
      isFullUrl: !o.resource.id,
      editor
    });
    const auditEntry = createBundleEntry("POST", auditEvent);
    return auditEntry;
  });
  const bundle = createBundle([...resourceEntries, ...auditEntries]);
  return bundle;
};
var createAuditBundleWithMethods = (auditResources, editor, eventCode) => {
  const resourceEntries = auditResources.map(({ method, resource, fullUrl }, key) => {
    const entry = mapResourceToBundleEntry(method, fullUrl)(resource);
    if (entry.fullUrl) {
      return entry;
    }
    return attachBundleFullUrl(entry, `__key_${key}`);
  });
  const auditEntries = resourceEntries.map((o) => {
    const auditEvent = createAuditEvent({
      editor,
      event: eventCode,
      toWhatId: o.resource.id || o.fullUrl,
      toWhatResource: o.resource.resourceType,
      when: /* @__PURE__ */ new Date(),
      isFullUrl: !o.resource.id
    });
    const auditEntry = createBundleEntry("POST", auditEvent);
    return auditEntry;
  });
  const bundle = createBundle([...resourceEntries, ...auditEntries]);
  return bundle;
};
var createUnreferencedAuditResource = (method, resource) => {
  return {
    method,
    resource
  };
};
var createUnreferencedAuditPOSTResource = (resource) => createUnreferencedAuditResource("POST", resource);
var createAuditResource = (resource, method, fullUrlKey) => ({
  resource,
  method,
  fullUrl: generateBundleReferenceId(resource.resourceType, fullUrlKey)
});
var createAuditResourceReference = (auditResource) => ({
  reference: auditResource.fullUrl
});

// src/mapping/device.ts
import { compact as compact3, partial as partial2, uniq as uniq2 } from "@quromedical/utils";
var mapRelayToDevice = (name) => ({
  resourceType: "Device",
  type: {
    coding: [
      {
        system,
        code: "device.relay" /* relay */
      }
    ]
  },
  status: "active",
  identifier: [
    {
      system,
      type: {
        coding: [
          {
            code: "identifier.device.type" /* deviceType */
          }
        ]
      },
      value: "device.relay" /* relay */
    }
  ],
  deviceName: [
    {
      name,
      type: "user-friendly-name"
    }
  ]
});
var mapPatchToDevice = (name) => ({
  resourceType: "Device",
  type: {
    coding: [
      {
        system,
        code: "device.patch" /* patch */
      }
    ]
  },
  status: "active",
  identifier: [
    {
      system,
      type: {
        coding: [
          {
            code: "identifier.device.type" /* deviceType */
          }
        ]
      },
      value: "device.patch" /* patch */
    }
  ],
  deviceName: [
    {
      name,
      type: "manufacturer-name"
    }
  ]
});
var isDeviceOfType = (code, device) => {
  const codes = device.type?.coding;
  const types2 = codes?.map((c) => c.code);
  const hasCode = !!types2?.includes(code);
  const identifiers = device.identifier;
  const values3 = identifiers?.map((i) => i.value);
  const hasValue = !!values3?.includes(code);
  return hasCode || hasValue;
};
var getDeviceTypeCodes = (device) => {
  const codes = device.type?.coding;
  const identifiers = device.identifier?.map((i) => i.value) || [];
  const types2 = codes?.map((c) => c.code) || [];
  return uniq2(compact3([...types2, ...identifiers]));
};
var isDevicePatch = partial2(isDeviceOfType, "device.patch" /* patch */);
var isDeviceRelay = partial2(isDeviceOfType, "device.relay" /* relay */);
var isDeviceBand = partial2(isDeviceOfType, "device.band" /* band */);
var getEffectiveTimes = (deviceUseStatement) => {
  const startTime = deviceUseStatement.timingPeriod?.start ? new Date(deviceUseStatement.timingPeriod.start) : /* @__PURE__ */ new Date();
  const endTime = deviceUseStatement.timingPeriod?.end ? new Date(deviceUseStatement.timingPeriod.end) : void 0;
  return { startTime, endTime };
};
var getDeviceName = (device, ...types2) => {
  if (!device?.deviceName?.length) {
    return void 0;
  }
  const foundName = device.deviceName.find((n) => types2.includes(n.type));
  if (!foundName) {
    return device.deviceName[0].name;
  }
  return foundName.name;
};
var getDeviceFriendlyName = (device) => getDeviceName(device, "user-friendly-name");
var getDeviceFriendlyNames = (devices) => {
  const names = devices.map(getDeviceFriendlyName);
  return compact3(names);
};
var createDeviceRef = (device) => {
  const display = getDeviceFriendlyName(device);
  const ref = createReference("Device", device.id, display);
  return ref;
};
var getDeviceUseStatementsForDevice = (deviceId, deviceUseStatements) => {
  const result = deviceUseStatements.filter((o) => {
    const ref = getReferenceId(o.device);
    return ref === deviceId;
  });
  return result;
};
var getDevicesByCode = (devices, code) => devices.filter((device) => isDeviceOfType(code, device));
var DeviceLifecycleMap = {
  ["deviceusestatement.patch" /* patch */]: {
    deviceCode: "device.patch" /* patch */,
    lifecycle: "disposable"
  },
  ["deviceusestatement.band" /* band */]: {
    deviceCode: "device.band" /* band */,
    lifecycle: "reusable"
  },
  ["deviceusestatement.relay" /* relay */]: {
    deviceCode: "device.relay" /* relay */,
    lifecycle: "reusable"
  },
  ["deviceusestatement.glucose" /* glucose */]: {
    deviceCode: "device.glucose" /* glucose */,
    lifecycle: "reusable"
  },
  ["deviceusestatement.bloodPressure" /* bloodPressure */]: {
    deviceCode: "device.bloodpressure" /* bloodPressure */,
    lifecycle: "reusable"
  }
};
var deviceDetails = Object.values(DeviceLifecycleMap);
var getDeviceLifecycle = (code) => {
  if (!code) {
    return void 0;
  }
  return DeviceLifecycleMap[code];
};
var getLifecycleForDeviceCode = (deviceCode) => {
  if (!deviceCode) {
    return void 0;
  }
  return deviceDetails.find((device) => device.deviceCode === deviceCode);
};

// src/mapping/coding.ts
import { flatten, first, compact as compact4, intersectionwith, unionby } from "@quromedical/utils";
var getCodes = (codeableConcept) => {
  if (!codeableConcept) {
    return [];
  }
  const { coding = [] } = codeableConcept;
  const codes = coding.map((c) => c.code);
  return compact4(codes);
};
var mergeCodes = (codeableConcepts = []) => {
  const codeMatrix = codeableConcepts.map((code) => getCodes(code));
  return flatten(codeMatrix);
};
var findIdentifier = (code, identifier) => identifier?.find((i) => i.type?.coding?.find((c) => c.code === code));
var getIdentifier = (code, identifier) => findIdentifier(code, identifier)?.value;
var removeIdentifier = (code, identifier) => {
  if (!identifier) {
    return [];
  }
  return identifier.filter((i) => !i.type?.coding?.find((c) => c.code === code));
};
var createCoding = (code, display = code, system2 = system, version) => ({
  code,
  system: system2,
  display,
  version
});
var createCodeableConcept = (code, text = code, display, system2 = system, version) => {
  const coding = createCoding(code, display, system2, version);
  return {
    text,
    coding: [coding]
  };
};
var getSupportedCode = (supportedCodes, resourceCodings) => {
  if (!resourceCodings?.length) {
    return void 0;
  }
  const codes = intersectionwith(
    resourceCodings,
    supportedCodes,
    (resourceCoding, supportedCode) => supportedCode === resourceCoding.code
  );
  const uniqueCodes = unionby(codes, "code");
  const [uniqueCode] = uniqueCodes;
  if (uniqueCodes.length !== 1 || !uniqueCode?.system) {
    return void 0;
  }
  return uniqueCode;
};
var isCodingInList = (searchCode, codings) => {
  const foundCode = codings?.find((c) => c.code === searchCode);
  return !!foundCode;
};
var getFirstCodeFromCodableConcepts = (codeableConcepts) => {
  if (!codeableConcepts || codeableConcepts.length === 0) {
    return void 0;
  }
  const codes = mergeCodes(codeableConcepts);
  return first(codes);
};
var getDisplayFromCodableConcepts = (codeableConcepts) => {
  if (!codeableConcepts || codeableConcepts.length === 0) {
    return void 0;
  }
  const displays = codeableConcepts.map((code) => code.coding?.map((coding) => coding.display));
  const texts = compact4(flatten(displays));
  return first(texts);
};
var getCodingsFromCodableConcepts = (codeableConcepts) => {
  if (!codeableConcepts || codeableConcepts.length === 0) {
    return void 0;
  }
  const codes = codeableConcepts.map((codeableConcept) => codeableConcept.coding);
  return flatten(codes);
};

// src/mapping/identifier.ts
var createSystemIdentifier = (code, value, systemUrl) => ({
  system: systemUrl,
  value,
  type: createCodeableConcept(code)
});
var createIdentifier = (code, value, systemUrl = system) => createSystemIdentifier(code, value, systemUrl);

// src/mapping/practitioner.ts
import { compact as compact5, first as first2 } from "@quromedical/utils";
var getFirstValueWhere = (condition, arr) => arr?.filter(condition).map((c) => c.value).filter((v) => v)[0] || "";
var mapSecondaryNumbersToTelecom = (number) => {
  if (!number) {
    return void 0;
  }
  return {
    system: "phone",
    value: number,
    rank: 2
  };
};
var mapPrimaryNumberToTelecom = (phone) => {
  if (!phone) {
    return void 0;
  }
  return {
    system: "phone",
    value: phone,
    rank: 1
  };
};
var mapPhoneNumbersToTelecom = (numbers) => {
  if (!numbers) {
    return [];
  }
  const [primaryNumber, secondaryNumber] = numbers;
  const primary = mapPrimaryNumberToTelecom(primaryNumber);
  const secondary = mapSecondaryNumbersToTelecom(secondaryNumber);
  return compact5([primary, secondary]);
};
var mapSecondaryTelecomToNumbers = (practitioner) => {
  if (practitioner.telecom) {
    return first2(practitioner.telecom.filter((t) => t.rank && t.rank > 1 && t.value));
  }
  return void 0;
};
var getEmailFromPractitioner = (practitioner) => getFirstValueWhere(
  (c) => c.system === "email" && c.rank === 1,
  practitioner.telecom || []
);
var getPrimaryPhoneNumberFromPractitioner = (practitioner) => getFirstValueWhere(
  (c) => c.system === "phone" && c.rank === 1,
  practitioner.telecom || []
);
var getSecondaryPhoneNumberFromPractitioner = (practitioner) => getFirstValueWhere(
  (c) => c.system === "phone" && c.rank === 2,
  practitioner.telecom || []
);
var getPractitionerName = (practitioner) => {
  const name = practitioner.name?.find((n) => n.text);
  return name?.text;
};
var createPractitionerRef = (practitioner) => {
  const display = getPractitionerName(practitioner);
  const id = practitioner.id || "";
  const ref = createReference("Practitioner", id, display);
  return ref;
};
var createPractitionerRefWithId = (practitioner) => {
  const display = getPractitionerName(practitioner);
  const ref = createReference("Practitioner", practitioner.id, display);
  return ref;
};
var createRegistrationIdentifier = (registrationNumber) => ({
  system,
  use: "official",
  type: {
    coding: [
      {
        code: "identifier.practitioner.registrationnumber" /* registrationNumber */
      }
    ]
  },
  value: registrationNumber
});

// src/mapping/encounter/index.ts
var fillerEncountersByLocations = (encounters, locationIds) => {
  const locations = new Set(locationIds);
  return encounters.filter((encounter) => {
    const encounterLocations = encounter.location || [];
    return encounterLocations.some((location) => {
      const id = getReferenceId(location.location) || "";
      return locations.has(id);
    });
  });
};
var getSubjectsFromEncounters = (encounters) => {
  return encounters.reduce((memo, encounter) => {
    const id = getReferenceId(encounter.subject);
    if (id) {
      memo.push(id);
    }
    return memo;
  }, []);
};

// src/mapping/device-use-statement.ts
import { getOverlap, hasOverlap } from "@quromedical/utils";
import { compact as compact6 } from "@quromedical/utils";
var isDeviceUseStatementActive = (deviceUseStatement) => deviceUseStatement?.status === "active";
var mapDeviceUseStatementToSubjectAndDevice = (deviceUseStatement) => ({
  subjectId: deviceUseStatement?.subject,
  deviceId: deviceUseStatement?.device
});
var getDeviceIdFromDeviceUseStatements = (deviceUseStatements) => {
  const deviceIds = deviceUseStatements.map((o) => {
    const link = mapDeviceUseStatementToSubjectAndDevice(o);
    const id = getReferenceId(link.deviceId);
    return id;
  });
  return compact6(deviceIds);
};
var setDeviceUseStatementEnd = (o) => {
  const end = (/* @__PURE__ */ new Date()).toISOString();
  const timingPeriod = o.timingPeriod ? {
    ...o.timingPeriod,
    end
  } : { end };
  return {
    ...o,
    status: "completed",
    timingPeriod
  };
};
var isDeviceUseStatementOfType = (deviceUseStatement, deviceType) => mergeCodes(deviceUseStatement.reasonCode).includes(deviceType);
var isActiveDeviceUseStatement = (deviceUseStatement, deviceType) => {
  const isExpectedDeviceType = isDeviceUseStatementOfType(deviceUseStatement, deviceType);
  if (!isExpectedDeviceType) {
    return false;
  }
  const isActive = deviceUseStatement.status === "active";
  const isPeriodIncomplete = isDeviceUseStatementActive(deviceUseStatement);
  return isActive || isPeriodIncomplete;
};
var createDeviceUseStatementTimeframeFilter = (endTime, startTime) => (o) => {
  if (!o?.timingPeriod?.start) {
    return false;
  }
  const { start, end } = o.timingPeriod;
  const obsStartTime = new Date(start);
  const startsBeforeEnd = obsStartTime < endTime;
  if (!end) {
    return startsBeforeEnd;
  }
  const obsEndTime = new Date(end);
  const overlaps = hasOverlap(startTime, endTime, obsStartTime, obsEndTime);
  return overlaps;
};
var getTime = (fhirDateTime) => {
  if (!fhirDateTime) {
    return void 0;
  }
  return new Date(fhirDateTime).getTime();
};
var getDeviceUseTiming = (deviceUseStatement) => {
  const { device, timingPeriod } = deviceUseStatement;
  const deviceName = device.display;
  if (!deviceName) {
    return void 0;
  }
  const start = getTime(timingPeriod?.start);
  if (!start) {
    return void 0;
  }
  const end = getTime(timingPeriod?.end);
  return {
    deviceName,
    start,
    end
  };
};
var getDeviceUseStatementOverlapPeriod = ({ deviceUseStatement, from, to, timingEndFallback = to }) => {
  const timing = getDeviceUseTiming(deviceUseStatement);
  if (!timing) {
    return void 0;
  }
  const overlap = getOverlap(from, to, timing.start, timing.end || timingEndFallback);
  if (!overlap) {
    return void 0;
  }
  const { deviceName } = timing;
  const { start, end } = overlap;
  return {
    deviceName,
    start,
    end
  };
};
var getDeviceUseStatementOverlapPeriods = ({ deviceUseStatements, ...rest }) => deviceUseStatements.map(
  (deviceUseStatement) => getDeviceUseStatementOverlapPeriod({
    ...rest,
    deviceUseStatement
  })
);

// src/mapping/extension/index.ts
import { flatten as flatten2, valsOrNone as valsOrNone2 } from "@quromedical/utils";
import { compact as compact7, isarray } from "@quromedical/utils";

// src/mapping/extension/url.ts
var ExtensionUrl = /* @__PURE__ */ ((ExtensionUrl2) => {
  ExtensionUrl2["addressEmergencyAccess"] = "http://quromedical.com/fhir/StructureDefinition/address-emergencyAccess";
  ExtensionUrl2["addressLongitude"] = "http://quromedical.com/fhir/StructureDefinition/address-longitude";
  ExtensionUrl2["addressLatitude"] = "http://quromedical.com/fhir/StructureDefinition/address-latitude";
  ExtensionUrl2["addressGooglePlaceId"] = "http://quromedical.com/fhir/StructureDefinition/address-googlePlaceId";
  ExtensionUrl2["riskClassification"] = "https://quromedical.co.za/StructureDefinition/patient-riskClassification";
  ExtensionUrl2["admissionICD10Code"] = "https://quromedical.co.za/StructureDefinition/patient-admissionICD10Code";
  ExtensionUrl2["medicalAidAuthorizationCode"] = "https://quromedical.co.za/StructureDefinition/patient-medicalAidAuthorizationCode";
  ExtensionUrl2["latestStatus"] = "https://quromedical.co.za/StructureDefinition/patient-latestStatus";
  ExtensionUrl2["assignedOrganization"] = "https://quromedical.co.za/StructureDefinition/patient-assignedOrganization";
  ExtensionUrl2["encounterOxygenRate"] = "https://quromedical.co.za/StructureDefinition/encounter-oxygenRate";
  ExtensionUrl2["encounterAttachment"] = "https://quromedical.co.za/StructureDefinition/encounter-attachment";
  ExtensionUrl2["encounterHospitalizationSchemeCode"] = "https://quromedical.co.za/StructureDefinition/encounter-hospitalizationSchemeCode";
  ExtensionUrl2["encounterHospitalizationSubscriberId"] = "https://quromedical.co.za/StructureDefinition/encounter-hospitalizationSsubscriberId";
  ExtensionUrl2["encounterHospitalizationDependentCode"] = "https://quromedical.co.za/StructureDefinition/encounter-hospitalizationDependentCode";
  ExtensionUrl2["encounterHospitalizationAuthorizationDate"] = "https://quromedical.co.za/StructureDefinition/encounter-hospitalizationAuthorizationDate";
  ExtensionUrl2["initialGroup"] = "https://quromedical.co.za/StructureDefinition/practitioner-initialGroup";
  ExtensionUrl2["medicationRequestPrescriber"] = "https://quromedical.co.za/StructureDefinition/practitioner-medicationRequestPrescriber";
  ExtensionUrl2["clinicalImpressionNoteCode"] = "https://quromedical.co.za/StructureDefinition/clinicalimpression-noteCode";
  ExtensionUrl2["clinicalImpressionLocationCode"] = "https://quromedical.co.za/StructureDefinition/clinicalimpression-locationType";
  ExtensionUrl2["clinicalImpressionAssessmentCode"] = "https://quromedical.co.za/StructureDefinition/clinicalimpression-assessmentCode";
  ExtensionUrl2["clinicalImpressionPlanCode"] = "https://quromedical.co.za/StructureDefinition/clinicalimpression-planCode";
  ExtensionUrl2["clinicalImpressionPinned"] = "https://quromedical.co.za/StructureDefinition/clinicalimpression-pinned";
  ExtensionUrl2["clinicalImpressionStructuredContentJSON"] = "https://quromedical.co.za/StructureDefinition/clinicalimpression-structuredContentJSON";
  ExtensionUrl2["observationComponentDateTime"] = "https://quromedical.co.za/StructureDefinition/observation-componentDateTime";
  ExtensionUrl2["observationComponentSensorId"] = "https://quromedical.co.za/StructureDefinition/observation-componentSensorId";
  ExtensionUrl2["practitionerToNotify"] = "https://quromedical.co.za/StructureDefinition/resource-practitionerToNotify";
  ExtensionUrl2["supplyDeliveryTransportCost"] = "https://quromedical.co.za/StructureDefinition/supplyDelivery-transportCost";
  ExtensionUrl2["supplyDeliveryTransportCostFactor"] = "https://quromedical.co.za/StructureDefinition/supplyDelivery-transportCostFactor";
  ExtensionUrl2["claimItemChargeItemDefinition"] = "https://quromedical.co.za/StructureDefinition/claim-itemChargeItemDefinition";
  ExtensionUrl2["claimResponseItemTraceNumber"] = "https://quromedical.co.za/StructureDefinition/claimresponse-itemTraceNumber";
  ExtensionUrl2["medicationUsageGroupIdentifier"] = "https://quromedical.co.za/StructureDefinition/medicationusage-groupIdentifier";
  ExtensionUrl2["moneyFactor"] = "https://quromedical.co.za/StructureDefinition/money-factor";
  ExtensionUrl2["encounterPrimaryIcd10Code"] = "https://quromedical.co.za/StructureDefinition/encounter-primaryIcd10Code";
  ExtensionUrl2["serviceRequestCopyPractitioners"] = "https://quromedical.co.za/StructureDefinition/servicerequest-copyPractitioners";
  ExtensionUrl2["TaskRequestedPeriod"] = "https://quromedical.co.za/StructureDefinition/task-requestedPeriod";
  ExtensionUrl2["TaskRequestedPerformer"] = "https://quromedical.co.za/StructureDefinition/task-requestedPerformer";
  ExtensionUrl2["observationReferenceRangeComparator"] = "https://quromedical.co.za/StructureDefinition/observation-referenceRangeComparator";
  ExtensionUrl2["riskAssessmentRiskScore"] = "https://quromedical.co.za/StructureDefinition/riskassessment-riskScore";
  ExtensionUrl2["flagNote"] = "https://quromedical.co.za/StructureDefinition/flag-note";
  return ExtensionUrl2;
})(ExtensionUrl || {});

// src/mapping/extension/config.ts
var resourceExtensionConfigs = {
  Task: {
    requestedPeriod: "https://quromedical.co.za/StructureDefinition/task-requestedPeriod" /* TaskRequestedPeriod */
  },
  ClinicalImpression: {
    practitionersToNotify: ["https://quromedical.co.za/StructureDefinition/resource-practitionerToNotify" /* practitionerToNotify */],
    pinned: "https://quromedical.co.za/StructureDefinition/clinicalimpression-pinned" /* clinicalImpressionPinned */
  }
  // TODO: Register extensions for all resources here - should stop uncontrolled access
};

// src/mapping/extension/keys.ts
var extensionKeys = {
  // address
  ["http://quromedical.com/fhir/StructureDefinition/address-emergencyAccess" /* addressEmergencyAccess */]: "valueString",
  ["http://quromedical.com/fhir/StructureDefinition/address-googlePlaceId" /* addressGooglePlaceId */]: "valueString",
  ["http://quromedical.com/fhir/StructureDefinition/address-latitude" /* addressLatitude */]: "valueDecimal",
  ["http://quromedical.com/fhir/StructureDefinition/address-longitude" /* addressLongitude */]: "valueDecimal",
  // patient
  ["https://quromedical.co.za/StructureDefinition/patient-riskClassification" /* riskClassification */]: "valueString",
  ["https://quromedical.co.za/StructureDefinition/patient-admissionICD10Code" /* admissionICD10Code */]: "valueCoding",
  ["https://quromedical.co.za/StructureDefinition/patient-medicalAidAuthorizationCode" /* medicalAidAuthorizationCode */]: "valueIdentifier",
  ["https://quromedical.co.za/StructureDefinition/patient-latestStatus" /* latestStatus */]: "valueCode",
  // practitioner
  ["https://quromedical.co.za/StructureDefinition/practitioner-initialGroup" /* initialGroup */]: "valueReference",
  ["https://quromedical.co.za/StructureDefinition/practitioner-medicationRequestPrescriber" /* medicationRequestPrescriber */]: "valueBoolean",
  // clinical impression
  ["https://quromedical.co.za/StructureDefinition/clinicalimpression-noteCode" /* clinicalImpressionNoteCode */]: "valueCode",
  ["https://quromedical.co.za/StructureDefinition/clinicalimpression-locationType" /* clinicalImpressionLocationCode */]: "valueCode",
  ["https://quromedical.co.za/StructureDefinition/clinicalimpression-assessmentCode" /* clinicalImpressionAssessmentCode */]: "valueCode",
  ["https://quromedical.co.za/StructureDefinition/clinicalimpression-planCode" /* clinicalImpressionPlanCode */]: "valueCode",
  ["https://quromedical.co.za/StructureDefinition/clinicalimpression-pinned" /* clinicalImpressionPinned */]: "valueBoolean",
  ["https://quromedical.co.za/StructureDefinition/clinicalimpression-structuredContentJSON" /* clinicalImpressionStructuredContentJSON */]: "valueString",
  // observation
  ["https://quromedical.co.za/StructureDefinition/observation-componentDateTime" /* observationComponentDateTime */]: "valueDateTime",
  ["https://quromedical.co.za/StructureDefinition/observation-componentSensorId" /* observationComponentSensorId */]: "valueString",
  // extension to any resource at the top-level
  ["https://quromedical.co.za/StructureDefinition/resource-practitionerToNotify" /* practitionerToNotify */]: "valueReference",
  // encounter
  ["https://quromedical.co.za/StructureDefinition/encounter-oxygenRate" /* encounterOxygenRate */]: "valueQuantity",
  ["https://quromedical.co.za/StructureDefinition/encounter-attachment" /* encounterAttachment */]: "valueReference",
  ["https://quromedical.co.za/StructureDefinition/encounter-hospitalizationAuthorizationDate" /* encounterHospitalizationAuthorizationDate */]: "valueDate",
  ["https://quromedical.co.za/StructureDefinition/encounter-hospitalizationDependentCode" /* encounterHospitalizationDependentCode */]: "valueString",
  ["https://quromedical.co.za/StructureDefinition/encounter-hospitalizationSchemeCode" /* encounterHospitalizationSchemeCode */]: "valueString",
  ["https://quromedical.co.za/StructureDefinition/encounter-hospitalizationSsubscriberId" /* encounterHospitalizationSubscriberId */]: "valueString",
  // supplyDelivery
  ["https://quromedical.co.za/StructureDefinition/supplyDelivery-transportCost" /* supplyDeliveryTransportCost */]: "valueMoney",
  ["https://quromedical.co.za/StructureDefinition/supplyDelivery-transportCostFactor" /* supplyDeliveryTransportCostFactor */]: "valueDecimal",
  // claim
  ["https://quromedical.co.za/StructureDefinition/claim-itemChargeItemDefinition" /* claimItemChargeItemDefinition */]: "valueReference",
  // claimResponseItemTraceNumber
  ["https://quromedical.co.za/StructureDefinition/claimresponse-itemTraceNumber" /* claimResponseItemTraceNumber */]: "valueString",
  // medicationUsage
  ["https://quromedical.co.za/StructureDefinition/medicationusage-groupIdentifier" /* medicationUsageGroupIdentifier */]: "valueString",
  // money
  ["https://quromedical.co.za/StructureDefinition/money-factor" /* moneyFactor */]: "valueDecimal",
  // Encounter
  ["https://quromedical.co.za/StructureDefinition/encounter-primaryIcd10Code" /* encounterPrimaryIcd10Code */]: "valueBoolean",
  // Service Request
  ["https://quromedical.co.za/StructureDefinition/servicerequest-copyPractitioners" /* serviceRequestCopyPractitioners */]: "valueReference",
  // Task
  ["https://quromedical.co.za/StructureDefinition/task-requestedPeriod" /* TaskRequestedPeriod */]: "valuePeriod",
  ["https://quromedical.co.za/StructureDefinition/task-requestedPerformer" /* TaskRequestedPerformer */]: "valueReference",
  //Observation
  ["https://quromedical.co.za/StructureDefinition/observation-referenceRangeComparator" /* observationReferenceRangeComparator */]: "valueString",
  // RiskAssessment
  ["https://quromedical.co.za/StructureDefinition/riskassessment-riskScore" /* riskAssessmentRiskScore */]: "valueDecimal",
  //Flag
  ["https://quromedical.co.za/StructureDefinition/flag-note" /* flagNote */]: "valueString",
  /**
   * @deprecated this search extension is no longer in use
   */
  ["https://quromedical.co.za/StructureDefinition/patient-assignedOrganization" /* assignedOrganization */]: "valueReference"
};

// src/mapping/extension/index.ts
var findExtension = (url, extensions = []) => extensions.find((e) => e.url === url);
var filterExtensions = (url, extensions = []) => extensions.filter((e) => e.url === url);
var updateExtensions = (updateExtensionUrl, existingExtensions = [], newExtensions = []) => {
  const retainExtensions = existingExtensions?.filter((ext) => ext.url !== updateExtensionUrl);
  return valsOrNone2([...retainExtensions, ...newExtensions]);
};
var getExtensionValue = (url) => (extension) => extension && extension[extensionKeys[url]];
var createExtensionValue = (url) => (value) => ({
  url,
  [extensionKeys[url]]: value
});
var findExtensionValue = (url) => (extensions = []) => {
  const foundExtension = extensions.find((e) => e.url === url);
  const extensionValue = getExtensionValue(url)(foundExtension);
  return extensionValue;
};
var filterExtensionValues = (url) => (extensions = []) => {
  const foundExtensions = extensions.filter((e) => e.url === url).map(getExtensionValue(url));
  return compact7(foundExtensions);
};
var addExtensionToResource = (resource, extension) => {
  const newExtensions = Array.isArray(extension) ? extension : [extension];
  const resourceExtensions = resource.extension || [];
  const combinedExtensions = [...resourceExtensions, ...newExtensions];
  return {
    ...resource,
    extension: valsOrNone2(combinedExtensions)
  };
};
var isMultiExtension = (data) => Array.isArray(data);
var getExtensionUrl = (url) => {
  if (isMultiExtension(url)) {
    return url[0];
  }
  return url;
};
var mapExtensionsToData = (resource) => {
  const { extension, resourceType } = resource;
  const resourceConfig = resourceExtensionConfigs[resourceType];
  if (!resourceConfig) {
    return {};
  }
  const entries = Object.entries(resourceConfig);
  const result = entries.reduce((prev, curr) => {
    const [key, extensionConfig] = curr;
    const extensionUrl = getExtensionUrl(extensionConfig);
    const handler = isMultiExtension(extensionConfig) ? filterExtensionValues : findExtensionValue;
    return {
      ...prev,
      [key]: handler(extensionUrl)(extension)
    };
  }, {});
  return result;
};
var createMultipleExtensions = (url, extensionDataArray) => {
  return extensionDataArray.map((val) => createExtensionValue(url)(val));
};
var mapDataToExtensions = (resource, extensionData) => {
  const resourceConfig = resourceExtensionConfigs[resource.resourceType];
  if (!resourceConfig) {
    return void 0;
  }
  const keys = Object.keys(extensionData);
  const extension = keys.map((key) => {
    const configUrl = resourceConfig[key];
    const extensionUrl = getExtensionUrl(configUrl);
    const data = extensionData[key];
    if (!data) {
      return;
    }
    const result = !isarray(data) ? createExtensionValue(extensionUrl)(data) : createMultipleExtensions(getExtensionUrl(extensionUrl), data);
    return result;
  });
  return compact7(flatten2(extension));
};

// src/mapping/patient.ts
var getRisk = (patient) => {
  const risk = patient.extension?.find(
    (e) => e.url === "https://quromedical.co.za/StructureDefinition/patient-riskClassification" /* riskClassification */ && e.valueCode
  );
  return risk ? risk.valueCode : void 0;
};
var createRiskExtension = (risk) => ({
  url: "https://quromedical.co.za/StructureDefinition/patient-riskClassification" /* riskClassification */,
  valueCode: risk
});
var getPatientNameDisplay = (patient) => {
  const names = patient.name;
  const name = names?.find((n) => n.text);
  return name?.text;
};
var createPatientRef = (patient) => {
  const name = getPatientNameDisplay(patient);
  const id = patient.id || "";
  const ref = createReference("Patient", id, name);
  return ref;
};
var createPatientRefWithId = (patient) => {
  const name = getPatientNameDisplay(patient);
  const id = patient.id;
  const ref = createReference("Patient", id, name);
  return ref;
};

// src/mapping/humanName.ts
import { compact as compact8, first as first3 } from "@quromedical/utils";
var getNameText = (givenName = "", familyName = "") => `${givenName} ${familyName}`.trim();
var getPersonName = (person) => {
  const givenName = first3(person.name)?.given?.join(" ") || "";
  const familyName = first3(person.name)?.family || "";
  return getNameText(givenName, familyName);
};
var createHumanName = (givenName, familyName, use = "official") => {
  const given = givenName?.trim().length ? [givenName] : void 0;
  const family = familyName?.trim();
  const hasName = given || family;
  if (!hasName) {
    return void 0;
  }
  const text = getNameText(givenName, familyName);
  return [
    {
      use,
      given,
      family,
      text
    }
  ];
};
var createFullHumanName = ({
  use = "official",
  family,
  given,
  prefix
}) => {
  const givenTrimmed = given?.trim();
  const familyTrimmed = family?.trim();
  const hasName = givenTrimmed || familyTrimmed;
  if (!hasName) {
    return void 0;
  }
  const text = getNameText(givenTrimmed, familyTrimmed);
  return [
    {
      use,
      text,
      family: familyTrimmed,
      given: givenTrimmed ? [givenTrimmed] : void 0,
      prefix: prefix ? [prefix] : void 0
    }
  ];
};
var getNamesFromText = (text) => {
  if (!text) {
    return {};
  }
  const [givenName, ...rest] = text.split(" ");
  const familyName = rest.join(" ");
  return {
    givenName,
    familyName
  };
};
var getPersonNames = (person) => {
  const names = person.name;
  const fallbackName = first3(names);
  if (!fallbackName) {
    return {};
  }
  const officialNames = person.name?.filter((n) => n.use === "official");
  const name = first3(officialNames) || fallbackName;
  const prefix = first3(name.prefix);
  const given = name.given?.join(" ");
  const { family } = name;
  const textNames = getNamesFromText(name.text);
  return {
    prefix,
    givenName: given || textNames.givenName,
    familyName: family || textNames.familyName
  };
};
var getDisplayName = (person) => {
  const name = getPersonNames(person);
  return compact8([name.givenName, name.familyName]).join(" ");
};
var getDisplayNameWithPrefix = (person) => {
  const { familyName, givenName, prefix } = getPersonNames(person);
  return compact8([prefix, givenName, familyName]).join(" ");
};

// src/mapping/date.ts
import { parseDate } from "@quromedical/utils";
import { differenceInDays } from "date-fns";

// src/utils/resource.ts
import { v4 as uuid } from "uuid";
var createRandomResourceReference = (resourceType) => {
  const id = uuid();
  return {
    reference: `${resourceType}/${id}`
  };
};

// src/utils/reference.ts
var filterReferencesByType = (resourceType, references = []) => references.filter((ref) => getReferenceType(ref) === resourceType);

// src/utils/assignment.ts
import { compact as compact9, intersection as intersection2 } from "@quromedical/utils";
var isPatientAssignedToPractitioner = (practitioner, patient) => {
  const practitionerRef = createReference("Practitioner", practitioner.id);
  const { generalPractitioner = [] } = patient;
  const allowedPractitionerRefs = filterReferencesByType("Practitioner", generalPractitioner).map(
    (ref) => ref.reference
  );
  const directAccessRef = allowedPractitionerRefs.find((ref) => ref === practitionerRef.reference);
  return !!directAccessRef;
};
var isPatientAssignedToPractitionerGroup = (activeMemberGroups, patient) => {
  const groupOrgRefs = compact9(activeMemberGroups.map((group) => group.managingEntity?.reference));
  const allowedOrgRefs = filterReferencesByType("Organization", patient.generalPractitioner).map(
    (ref) => ref.reference
  );
  const commonOrgs = intersection2(compact9(allowedOrgRefs), groupOrgRefs);
  const hasCommonOrgs = commonOrgs.length > 0;
  return hasCommonOrgs;
};
var isPatientAssignedToPractitionerOrGroups = (patient, practitioner, activeMemberGroups) => {
  if (!practitioner.id) {
    return false;
  }
  const directAccess = isPatientAssignedToPractitioner(practitioner, patient);
  const indirectAccess = isPatientAssignedToPractitionerGroup(activeMemberGroups, patient);
  return directAccess || indirectAccess;
};

// src/utils/task.ts
import { isBefore, parseISO } from "date-fns";
var setTaskOverdue = (tasks) => tasks.map((item) => ({ ...item, status: "failed" }));
var isPeriodComplete = (period) => period.end !== void 0;
var createPeriod = (start, end) => ({
  start: createFhirDate(start),
  end: createFhirDate(end)
});
var filterByRequestedPeriod = (tasks) => tasks.filter((fhirTask) => {
  const requestedPeriodExtensions = filterExtensions(
    "https://quromedical.co.za/StructureDefinition/task-requestedPeriod" /* TaskRequestedPeriod */,
    fhirTask.extension
  );
  const extensionReferences = requestedPeriodExtensions.map((ext) => ext.valuePeriod);
  const requestedPeriod = extensionReferences[0];
  if (!requestedPeriod || !isPeriodComplete(requestedPeriod) || !isBefore(parseISO(requestedPeriod.end), /* @__PURE__ */ new Date())) {
    return void 0;
  }
  return fhirTask;
});

// src/utils/pagination.ts
var getNextPageToken = (bundleLink) => {
  if (!bundleLink) {
    return void 0;
  }
  const itemUrl = new URL(bundleLink.url);
  const pageToken = itemUrl.searchParams.get("_page_token");
  return pageToken || void 0;
};
var getNextLink = (bundle) => bundle.link?.find((l) => l.relation === "next");
var getPageTokenFromBundle = (bundle) => {
  const foundLink = getNextLink(bundle);
  return getNextPageToken(foundLink);
};

// src/mapping/date.ts
var createFhirDate = (date) => date.toISOString().split("T")[0];
function createOptionalFhirDate(date) {
  if (!date) {
    return void 0;
  }
  const d = new Date(date);
  return createFhirDate(d);
}
var createFhirDateTime = (date) => date.toISOString();
var mapFhirToModelPeriod = (fhir) => {
  if (!fhir) {
    return void 0;
  }
  const { start, end } = fhir;
  if (!start) {
    return void 0;
  }
  return {
    start,
    end
  };
};
var isDateWithinPeriod = (date, period) => {
  const completePeriod = isPeriodComplete(period);
  const { start, end } = completePeriod ? period : { ...period, end: void 0 };
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : void 0;
  return startDate <= date && (!endDate || endDate >= date);
};
var getDurationInDays = (isoDate, relativeDate = Date.now()) => {
  const parsed = parseDate(isoDate);
  const relative = parseDate(relativeDate);
  const bothValid = parsed && relative;
  if (!bothValid) {
    return void 0;
  }
  return differenceInDays(relative, parsed);
};

// src/mapping/group.ts
import { compact as compact10, flatten as flatten3, partial as partial3, uniq as uniq3 } from "@quromedical/utils";
var securityCodes = Object.values(GroupSecurity);
var getGroupSecurityCodes = (group) => {
  const coding = group.code?.coding || [];
  const codes = coding.map((c) => c.code);
  const filteredCodes = compact10(codes).filter((c) => {
    const isSecurityCode = securityCodes.includes(c);
    return isSecurityCode;
  });
  return filteredCodes;
};
var getJointGroupSecurityCodes = (groups) => {
  const codes = groups.map(getGroupSecurityCodes);
  const flatCodes = flatten3(codes);
  return uniq3(flatCodes);
};
var updateGroupMembers = (membersToUpdate, group) => {
  const removeUnchangedMembers = (member) => {
    const foundMember = membersToUpdate.find(
      (u) => u?.entity?.reference && u.entity?.reference === member?.entity?.reference
    );
    return !foundMember;
  };
  const baseMembers = group.member || [];
  const unchangedMembers = baseMembers.filter(removeUnchangedMembers);
  const updatedMembers = unchangedMembers.concat(membersToUpdate);
  const updatedGroup = {
    ...group,
    member: valsOrNone(updatedMembers)
  };
  return updatedGroup;
};
var getOrganizationIds = (groups) => {
  const orgIds = groups.map((group) => getReferenceId(group.managingEntity));
  return compact10(orgIds);
};
var isGroupActive = (group) => !!group.active;
var getActiveGroupMembers = (group) => {
  return group.member?.filter((m) => !m.inactive);
};
var isActiveGroupMember = (practitionerId, group) => {
  const { member } = group;
  if (!member?.length) {
    return false;
  }
  const activeMembers = member.filter((m) => !m.inactive);
  const foundEntity = activeMembers.find((m) => {
    const ref = getReferenceData(m.entity);
    if (ref?.resourceType !== "Practitioner") {
      return false;
    }
    return ref.id === practitionerId;
  });
  return !!foundEntity;
};
var getGroupCodes = (group) => {
  const coding = group.code?.coding || [];
  const codes = coding.map((c) => c.code);
  const filteredCodes = compact10(codes).filter((c) => {
    const hasCode = securityCodes.includes(c);
    return hasCode;
  });
  return filteredCodes;
};
var joinCodes = (groups) => {
  const codes = groups.map(getGroupCodes);
  const flatCodes = flatten3(codes);
  return uniq3(flatCodes);
};
var getUserActiveGroupCodes = (groups, practitionerId) => {
  const activeGroups = groups.filter(isGroupActive);
  const practitionerGroups = activeGroups.filter((g) => isActiveGroupMember(practitionerId, g));
  return joinCodes(practitionerGroups);
};
var isPractitionerMemberActive = (practitionerId) => partial3(isActiveGroupMember, practitionerId);
var getGroupReferences = (userGroups) => userGroups.map((group) => createReference("Group", group.id, group.name));
function createGroupMemberEntity(resourceType, id) {
  return {
    entity: createReference(resourceType, id)
  };
}
function createGroupMemberEntityFromResource(resource) {
  return createGroupMemberEntity(resource.resourceType, resource.id);
}

// src/mapping/address.ts
var getCity = findProp("city");
var getPostalCode = findProp("postalCode");
var getAddressLines = findProp("line");
var countryDisplayMapping = {
  ["ZA" /* SouthAfrica */]: "South Africa",
  ["NA" /* Namibia */]: "Namibia"
};
var countryCodes = Object.values(CountryCode);
var isCountryCode = (code) => countryCodes.includes(code);
var getCountry = (address) => {
  const country = address?.country;
  const isValid = isCountryCode(country);
  if (!isValid) {
    return void 0;
  }
  return country;
};
var getFirstLine = (address = []) => {
  const lines = getAddressLines(address);
  return lines?.[0];
};

// src/mapping/contact-point.ts
import { compact as compact11, filter as filter2, sortby, values } from "@quromedical/utils";
var getPhone = (telecom = []) => {
  const phone = telecom.find((t) => t.system === "phone" && t.value);
  return phone?.value;
};
var getHomePhone = (telecom = []) => {
  const phone = telecom.find((t) => t.system === "phone" && t.value && t.use === "home");
  return phone?.value;
};
var getMobilePhone = (telecom = []) => {
  const phone = telecom.find((t) => t.system === "phone" && t.value && t.use === "mobile");
  return phone?.value;
};
var getEmail = (telecom = []) => {
  const email = telecom.find((t) => t.system === "email" && t.value);
  return email?.value;
};
var getPrimaryPhoneNumber = (telecom = []) => {
  const phone = telecom.filter((t) => t.rank && t.rank === 1 && t.value && t.system === "phone").map((t) => t.value);
  return phone?.[0];
};
var getSecondaryNumbers = (telecom = []) => {
  const phone = telecom.filter((t) => t.rank && t.rank > 1 && t.value).map((t) => t.value);
  return phone?.[0];
};
var getContactValues = (system2, telecom = []) => {
  const telecomWithValues = filter2(telecom, (t) => !!t.value);
  const telecomWithSystem = filter2(telecomWithValues, (t) => t.system === system2);
  const sortedByRank = sortby(telecomWithSystem, (phone) => phone.rank);
  const phonesNumbers = sortedByRank.map((phone) => phone.value);
  const compacted = compact11(phonesNumbers);
  return values(compacted);
};

// src/mapping/coverage.ts
var isPatientMainMember = ({ beneficiary, subscriber }) => !!beneficiary.reference && beneficiary.reference === subscriber?.reference;
var getPlan = (coverage) => coverage.class?.find(
  (coverageClass) => isCodingInList("plan" /* Plan */, coverageClass?.type?.coding)
);
var getSubPlan = (coverage) => coverage.class?.find(
  (coverageClass) => isCodingInList("subplan" /* SubPlan */, coverageClass?.type?.coding)
);
var allowedSubscriberTypes = ["Patient", "RelatedPerson"];
var getSubscriberType = (coverage) => {
  if (!coverage) {
    return void 0;
  }
  const subscriberType = getReferenceType(coverage.subscriber);
  const resolvedType = allowedSubscriberTypes.find((resourceType) => resourceType === subscriberType);
  return resolvedType;
};

// src/mapping/resource.ts
var findResourceByType = (resourceType, resources = []) => resources.find((resource) => resource.resourceType === resourceType);
var findResourcesByType = (resourceType, resources = []) => resources.filter((resource) => resource.resourceType === resourceType);

// src/mapping/organization.ts
import { uniqby } from "@quromedical/utils";
var createOrganizationRef = (organization) => createReferenceFromResource(organization, organization.name);
var getOrganizationReferences = (userGroups) => {
  const orgRefs = userGroups.map((group) => group.managingEntity).filter(isValidReference);
  const uniqOrgs = uniqby(orgRefs, (org) => org.reference);
  return uniqOrgs;
};

// src/mapping/quantity.ts
var createValidOxygenRate = (value) => {
  const hasValue = !!value;
  const isPositive = hasValue && value > 0;
  if (!isPositive) {
    return void 0;
  }
  return createQuantityWithValue({ value, code: "quantity.code.oxygenrate" /* OxygenRate */, unit: "L/min" });
};
var hasQuantityValue = (quantity) => typeof quantity?.value === "number";
var getQuantityWithValue = (quantity) => {
  if (!hasQuantityValue(quantity)) {
    return void 0;
  }
  return quantity;
};
var createQuantityWithValue = (params) => {
  const { value, unit, code, system: system2 = system } = params;
  const quantity = {
    value,
    code,
    system: system2
  };
  return unit ? { ...quantity, unit } : quantity;
};

// src/mapping/content-type.ts
var ContentType = /* @__PURE__ */ ((ContentType3) => {
  ContentType3["jpeg"] = "image/jpeg";
  ContentType3["png"] = "image/png";
  ContentType3["gif"] = "image/gif";
  ContentType3["pdf"] = "application/pdf";
  ContentType3["doc"] = "application/msword";
  ContentType3["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  ContentType3["odt"] = "application/vnd.oasis.opendocument.text";
  ContentType3["xls"] = "application/vnd.ms-excel";
  ContentType3["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  ContentType3["csv"] = "text/csv";
  ContentType3["dcm"] = "application/dicom";
  ContentType3["xml"] = "application/xml";
  ContentType3["zip"] = "application/zip";
  ContentType3["json"] = "application/json";
  ContentType3["ogg"] = "audio/ogg";
  ContentType3["mp4"] = "video/mp4";
  ContentType3["vcf"] = "text/vcard";
  ContentType3["webp"] = "image/webp";
  return ContentType3;
})(ContentType || {});
var contentTypes = Object.values(ContentType);
var Extension = /* @__PURE__ */ ((Extension2) => {
  Extension2["jpeg"] = "jpeg";
  Extension2["png"] = "png";
  Extension2["gif"] = "gif";
  Extension2["pdf"] = "pdf";
  Extension2["doc"] = "doc";
  Extension2["docx"] = "docx";
  Extension2["odt"] = "odt";
  Extension2["xls"] = "xls";
  Extension2["xlsx"] = "xlsx";
  Extension2["csv"] = "csv";
  Extension2["dcm"] = "dcm";
  Extension2["xml"] = "xml";
  Extension2["zip"] = "zip";
  Extension2["ogg"] = "ogg";
  Extension2["mp4"] = "mp4";
  Extension2["vcf"] = "vcf";
  Extension2["webp"] = "webp";
  Extension2["json"] = "json";
  return Extension2;
})(Extension || {});
var allowedExtensionTypeMap = {
  ["image/jpeg" /* jpeg */]: "jpeg" /* jpeg */,
  ["image/png" /* png */]: "png" /* png */,
  ["image/gif" /* gif */]: "gif" /* gif */,
  ["application/pdf" /* pdf */]: "pdf" /* pdf */,
  ["application/msword" /* doc */]: "doc" /* doc */,
  ["application/vnd.openxmlformats-officedocument.wordprocessingml.document" /* docx */]: "docx" /* docx */,
  ["application/vnd.oasis.opendocument.text" /* odt */]: "odt" /* odt */,
  ["application/vnd.ms-excel" /* xls */]: "xls" /* xls */,
  ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" /* xlsx */]: "xlsx" /* xlsx */,
  ["text/csv" /* csv */]: "csv" /* csv */,
  ["application/dicom" /* dcm */]: "dcm" /* dcm */,
  ["audio/ogg" /* ogg */]: "ogg" /* ogg */,
  ["video/mp4" /* mp4 */]: "mp4" /* mp4 */,
  ["text/vcard" /* vcf */]: "vcf" /* vcf */,
  ["image/webp" /* webp */]: "webp" /* webp */
};
var allowedContentTypes = Object.keys(
  allowedExtensionTypeMap
);
var allowedExtensions = Object.values(allowedExtensionTypeMap);
var allowedDocumentExtensions = [
  "csv" /* csv */,
  "dcm" /* dcm */,
  "doc" /* doc */,
  "docx" /* docx */,
  "json" /* json */,
  "odt" /* odt */,
  "pdf" /* pdf */,
  "xls" /* xls */,
  "xlsx" /* xlsx */,
  "xml" /* xml */
];
var getContentType = (contentType) => {
  if (!contentType) {
    return void 0;
  }
  const foundType = contentTypes.find((type) => contentType === type);
  return foundType;
};
var ContentTypeMap = {
  "image/jpeg": "image/jpeg" /* jpeg */,
  "image/png": "image/png" /* png */,
  "application/pdf": "application/pdf" /* pdf */,
  "application/msword": "application/msword" /* doc */,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "application/vnd.openxmlformats-officedocument.wordprocessingml.document" /* docx */,
  "application/vnd.oasis.opendocument.text": "application/vnd.oasis.opendocument.text" /* odt */,
  "application/vnd.ms-excel": "application/vnd.ms-excel" /* xls */,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" /* xlsx */,
  "text/csv": "text/csv" /* csv */,
  "application/dicom": "application/dicom" /* dcm */,
  "application/xml": "application/xml" /* xml */,
  "application/zip": "application/zip" /* zip */,
  "application/json": "application/json" /* json */,
  "audio/ogg": "audio/ogg" /* ogg */,
  "video/mp4": "video/mp4" /* mp4 */,
  "text/vcard": "text/vcard" /* vcf */,
  "image/webp": "image/webp" /* webp */
};
var ExtensionContentTypeMap = {
  ["jpeg" /* jpeg */]: "image/jpeg" /* jpeg */,
  ["png" /* png */]: "image/png" /* png */,
  ["gif" /* gif */]: "image/gif" /* gif */,
  ["pdf" /* pdf */]: "application/pdf" /* pdf */,
  ["doc" /* doc */]: "application/msword" /* doc */,
  ["docx" /* docx */]: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" /* docx */,
  ["odt" /* odt */]: "application/vnd.oasis.opendocument.text" /* odt */,
  ["xls" /* xls */]: "application/vnd.ms-excel" /* xls */,
  ["xlsx" /* xlsx */]: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" /* xlsx */,
  ["csv" /* csv */]: "text/csv" /* csv */,
  ["dcm" /* dcm */]: "application/dicom" /* dcm */,
  ["xml" /* xml */]: "application/xml" /* xml */,
  ["zip" /* zip */]: "application/zip" /* zip */,
  ["json" /* json */]: "application/json" /* json */,
  ["ogg" /* ogg */]: "audio/ogg" /* ogg */,
  ["mp4" /* mp4 */]: "video/mp4" /* mp4 */,
  ["vcf" /* vcf */]: "text/vcard" /* vcf */,
  ["webp" /* webp */]: "image/webp" /* webp */
};

// src/mapping/service-request.ts
var ampathPerformerReference = {
  identifier: {
    system,
    type: createCodeableConcept("identifier.servicerequest.performer" /* serviceRequestPerformer */),
    value: "servicerequest.performer.ampath" /* Ampath */
  }
};
var lancetPerformerReference = {
  identifier: {
    system,
    type: createCodeableConcept("identifier.servicerequest.performer" /* serviceRequestPerformer */),
    value: "servicerequest.performer.lancet" /* Lancet */
  }
};

// src/mapping/charge-item-definition.ts
import { compact as compact12 } from "@quromedical/utils";
var createChargeItemDefinitionApplicabilityExpression = (key, value) => `${key}=${value}`;
var createChargeItemDefinitionApplicabilityItem = (key, value, description) => ({
  description,
  language: CHARGE_ITEM_DEFINITION_APPLICABILITY_LANGUAGE,
  expression: createChargeItemDefinitionApplicabilityExpression(key, value)
});
var createChargeItemDefinitionApplicability = (conditions) => {
  const result = Object.keys(conditions).map((key) => {
    const condition = conditions[key];
    if (!condition) {
      return void 0;
    }
    return createChargeItemDefinitionApplicabilityItem(
      key,
      condition.value,
      condition.description
    );
  });
  return valsOrNone(compact12(result));
};
var isDefined = (value) => !!value;
var parseExpression = (expression = "") => {
  const [key, value] = expression.split("=");
  const isValid = isDefined(key) && isDefined(value);
  if (!isValid) {
    return void 0;
  }
  return [key, value];
};
var parseApplicabilityExpression = (applicability) => {
  const { language, description, expression } = applicability;
  if (language !== CHARGE_ITEM_DEFINITION_APPLICABILITY_LANGUAGE) {
    return void 0;
  }
  const parsed = parseExpression(expression);
  if (!parsed) {
    return void 0;
  }
  const [key, value] = parsed;
  const condition = {
    type: "equal",
    value,
    description
  };
  return [key, condition];
};
var getChargeItemDefinitionApplicabilityConditions = (applicability) => applicability.reduce((acc, current) => {
  const parsed = parseApplicabilityExpression(current);
  if (!parsed) {
    return acc;
  }
  const [key, value] = parsed;
  return {
    ...acc,
    [key]: value
  };
}, {});

// src/mapping/notes.ts
import { compact as compact13, filter as filter3, flatten as flatten4, values as values2 } from "@quromedical/utils";
var createNotePinnedExtension = createExtensionValue("https://quromedical.co.za/StructureDefinition/clinicalimpression-pinned" /* clinicalImpressionPinned */);
var findPinnedExtensionValue = findExtensionValue("https://quromedical.co.za/StructureDefinition/clinicalimpression-pinned" /* clinicalImpressionPinned */);
var isNotePinned = (clinicalImpression) => findPinnedExtensionValue(clinicalImpression.extension) || false;
var updateNoteAuditResources = (baseClinicalImpression, medias, pinned) => {
  const mediaEntries = medias.map(mapResourceToEntry).map(attachBundleFullUrl);
  const hasMedias = mediaEntries.length > 0;
  const mediaInvestigations = hasMedias ? {
    code: createCodeableConcept("clinicalimpression.investigation.code.media" /* Media */),
    item: mediaEntries.map((entry) => ({
      reference: entry.fullUrl
    }))
  } : void 0;
  const updatedClinicalImpression = pinned !== void 0 ? updatedPinnedStatus(baseClinicalImpression, pinned) : void 0;
  const currentInvestigations = baseClinicalImpression.investigation || [];
  const investigation = currentInvestigations || mediaInvestigations ? compact13([...currentInvestigations, mediaInvestigations]) : void 0;
  const result = updatedClinicalImpression || baseClinicalImpression;
  const clinicalImpression = {
    ...result,
    investigation
  };
  const auditResources = [
    {
      method: "PUT",
      resource: clinicalImpression
    },
    ...mediaEntries.map((entry) => ({
      method: "POST",
      resource: entry.resource,
      fullUrl: entry.fullUrl
    }))
  ];
  return auditResources;
};
var createNoteAuditResources = (baseClinicalImpression, medias, vitals) => {
  const mediaEntries = medias.map(mapResourceToEntry).map(attachBundleFullUrl);
  const vitalEntry = vitals && attachBundleFullUrl(mapResourceToEntry(vitals), "vitals");
  const vitalInvestigation = vitalEntry && {
    code: createCodeableConcept("clinicalimpression.investigation.code.latestvitals" /* LatestVitals */),
    item: [
      {
        reference: vitalEntry?.fullUrl
      }
    ]
  };
  const hasMedias = mediaEntries.length > 0;
  const mediaInvestigations = hasMedias ? {
    code: createCodeableConcept("clinicalimpression.investigation.code.media" /* Media */),
    item: mediaEntries.map((entry) => ({
      reference: entry.fullUrl
    }))
  } : void 0;
  const hasInvestigations = vitalInvestigation || mediaInvestigations;
  const investigation = hasInvestigations ? compact13([vitalInvestigation, mediaInvestigations]) : void 0;
  const clinicalImpression = {
    ...baseClinicalImpression,
    investigation
  };
  const clinicalImpressionEntry = attachBundleFullUrl(
    mapResourceToEntry(clinicalImpression),
    "clinical-impression"
  );
  const clinicalImpressionReference = createReferenceFromBundleEntry(clinicalImpressionEntry);
  const mediaAuditResource = mediaEntries.map((entry) => ({
    method: "POST",
    resource: { ...entry.resource, partOf: [{ reference: clinicalImpressionEntry.fullUrl }] },
    fullUrl: entry.fullUrl
  }));
  const auditResources = [
    {
      method: "POST",
      resource: clinicalImpressionEntry.resource,
      fullUrl: clinicalImpressionEntry.fullUrl
    },
    vitalEntry && {
      method: "POST",
      resource: vitalEntry.resource,
      fullUrl: vitalEntry.fullUrl
    },
    ...mediaAuditResource
  ];
  return [compact13(auditResources), clinicalImpressionReference];
};
var getInvestigationReferencesByCode = (code, referenceType, investigations) => {
  const filteredInvestigations = filter3(
    investigations,
    (investigation) => investigation.code.text === code
  );
  const mappedReferences = filteredInvestigations.map((investigation) => investigation.item);
  const flattenReferences = flatten4(mappedReferences);
  const compactedReferences = compact13(flattenReferences);
  const references = values2(compactedReferences);
  return filterReferencesByType(referenceType, references);
};
var updatedPinnedStatus = (clinicalImpression, pinned) => {
  const existingExtensions = clinicalImpression.extension;
  const pinnedExtension = createNotePinnedExtension(pinned);
  const extension = updateExtensions("https://quromedical.co.za/StructureDefinition/clinicalimpression-pinned" /* clinicalImpressionPinned */, existingExtensions, [
    pinnedExtension
  ]);
  return {
    ...clinicalImpression,
    extension
  };
};
var createAnnotation = (code, text) => ({
  text,
  extension: [
    {
      url: "https://quromedical.co.za/StructureDefinition/clinicalimpression-noteCode" /* clinicalImpressionNoteCode */,
      valueCode: code
    }
  ]
});
var addSubjectiveNote = (clinicalImpression, subjective) => {
  const existingAnnotations = clinicalImpression.note || [];
  const newAnnotation = createAnnotation("clinicalimpression.note.extension.code.soap.subjective" /* Subjective */, subjective);
  const note = [...existingAnnotations, newAnnotation];
  return {
    ...clinicalImpression,
    note
  };
};

// src/mapping/media.ts
import { kebabcase } from "@quromedical/utils";
var MediaUtils = class {
  constructor(storageClient) {
    this.storageClient = storageClient;
    this.getKeyFromUrl = (url) => {
      if (url.startsWith("https://") || url.startsWith("http://")) {
        const [, ...parts] = url.replace("https://", "").replace("http://", "").split("/");
        return parts.join("/");
      }
      return url;
    };
    this.replaceMediaUrl = (media, url) => {
      const content = { ...media.content, url };
      return { ...media, content };
    };
    this.populateMediaUrl = async (resource) => {
      const { content } = resource;
      const key = content.url ? this.storageClient.getKeyFromUrl(content.url) : void 0;
      const signedURL = key ? await this.storageClient.getSignedURL(key) : void 0;
      const updatedResource = this.replaceMediaUrl(resource, signedURL);
      return updatedResource;
    };
    this.populateSignedUrl = async (entry) => {
      const { resource } = entry;
      const updatedResource = await this.populateMediaUrl(resource);
      return { ...entry, resource: updatedResource };
    };
    this.replaceDataWithURL = (media, url) => {
      const { data: _, ...rest } = media.content;
      const content = { ...rest, url };
      return { ...media, content };
    };
    /**
     *
     * @param title title for the file
     * @param contentType MIME content type for the file
     * @param patientId ID for the patient that that the file is about
     * @param fileResourceType Resource Type that the file is linked to
     * @param extension use an extension in place of the content type derivation, e.g. `pdf` or `xml`
     * @param date the `Date` for the directory under which the file should be stored. Defaults to `now`
     *
     * @returns Path to the file in the form of
     * `patient/${patientId}/${date}/${dateTime}-${resource-type}-${extension | content-type extension}`
     */
    this.createKey = (title, contentType, patientId, fileResourceType = "Media", extension, date = /* @__PURE__ */ new Date()) => {
      const resourceLabel = kebabcase(fileResourceType);
      const resolvedExtension = extension || allowedExtensionTypeMap[contentType];
      const fhirDate = createFhirDate(date);
      const fhirDateTime = createFhirDateTime(date);
      const sanitizedTitle = title.replace(this.uriRegex, "");
      const key = `patient/${patientId}/${fhirDate}/${fhirDateTime}-${resourceLabel}-${sanitizedTitle}.${resolvedExtension}`;
      return key;
    };
    /**
     * Updates the data for a media and replaces it a url derived from the key
     */
    this.setMediaUrl = (key, initial) => {
      const url = this.storageClient.getFullFileUrl(key);
      const media = this.replaceDataWithURL(initial, url);
      return media;
    };
    this.uriRegex = /[^a-zA-Z0-9-_.]/g;
  }
};

// src/mapping/admission.ts
import { differenceInDays as differenceInDays2, isSameDay, startOfDay, isAfter } from "date-fns";
var hasEnd = (period) => "end" in period;
var hasStart = (period) => "start" in period;
var getPeriodDurationDays = (period) => {
  const isComplete = period && hasEnd(period);
  const days = getDurationInDays(period?.start, isComplete ? period?.end : void 0);
  if (days === void 0) {
    return void 0;
  }
  const relativeDay = days + 1;
  return relativeDay;
};
var getPeriod = (statusHistory) => {
  const endDate = startOfDay(
    statusHistory.status === "in-progress" || !statusHistory.period.end ? /* @__PURE__ */ new Date() : new Date(statusHistory.period.end)
  );
  const startDate = startOfDay(new Date(statusHistory.period.start));
  return {
    start: startDate,
    end: endDate
  };
};
var getInterval = (statusHistory) => {
  if (!statusHistory.length) {
    return void 0;
  }
  const first4 = statusHistory[0];
  const size = statusHistory.length;
  let last = statusHistory[size - 1];
  if (last.status === "onleave") {
    last = statusHistory[size - 2];
  }
  return {
    start: new Date(first4.period.start),
    end: new Date(last.period.end || Date.now())
  };
};
var getPeriodDayWithPausePeriod = (statusHistory, notePeriod) => {
  const interval = getInterval(statusHistory);
  if (!interval) {
    return void 0;
  }
  const { start, end } = interval;
  const isComplete = notePeriod && hasEnd(notePeriod);
  const noteEndDate = isComplete ? new Date(notePeriod?.end) : end;
  const daysInPeriod = differenceInDays2(noteEndDate, start);
  let onLeaveCount = 0;
  const onLeaveDays = statusHistory.reduce((amount, current) => {
    if (current.status !== "onleave") {
      return amount;
    }
    const period = getPeriod(current);
    if (isAfter(period.end, noteEndDate)) {
      return amount;
    }
    if (!isSameDay(period.start, period.end)) {
      onLeaveCount++;
    }
    const days = differenceInDays2(period.end, period.start);
    return amount + days;
  }, 0);
  return daysInPeriod - onLeaveDays + onLeaveCount + 1;
};

// src/mapping/relatedPerson.ts
var getRelatedPersonNameDisplay = (relatedPerson) => {
  const names = relatedPerson.name;
  const name = names?.find((n) => n.text);
  return name?.text;
};
var createRelatedPersonRefWithId = (relatedPerson) => {
  const name = getRelatedPersonNameDisplay(relatedPerson);
  const id = relatedPerson.id;
  const ref = createReference("RelatedPerson", id, name);
  return ref;
};

// src/validation/reference.ts
import * as yup from "yup";
var createInternalReferenceSchema = (expectedResourceType) => {
  const expectedReferenceType = `is${expectedResourceType}`;
  const errorMessage = `\${path} is not ${expectedResourceType} reference`;
  const schema = yup.string().test(expectedReferenceType, errorMessage, async (reference) => {
    const referenceData = getReferenceData({ reference });
    if (referenceData?.resourceType !== expectedResourceType) {
      return false;
    }
    const { id } = referenceData;
    return yup.string().uuid().isValid(id);
  });
  return schema;
};
var createMultipleInternalReferenceSchema = (expectedResourceType) => {
  const resourceList = expectedResourceType.join(", ");
  const expectedReferenceType = `is one of: ${resourceList}`;
  const errorMessage = `\${path} is not one of: ${resourceList}`;
  const schema = yup.string().test(expectedReferenceType, errorMessage, async (reference) => {
    const referenceData = getReferenceData({ reference });
    const hasData = referenceData?.resourceType && referenceData?.id;
    if (!hasData) {
      return false;
    }
    const { id, resourceType } = referenceData;
    const isValidType = expectedResourceType.includes(resourceType);
    if (!isValidType) {
      return false;
    }
    return yup.string().uuid().isValid(id);
  });
  return schema;
};
var createMultipleReferenceValidationSchema = (expectedResourceType) => {
  const referenceSchema = createMultipleInternalReferenceSchema(expectedResourceType);
  const schema = yup.object({
    reference: referenceSchema
  }).required();
  return schema;
};
var createReferenceValidationSchema = (expectedResourceType) => {
  const referenceSchema = createInternalReferenceSchema(expectedResourceType);
  const schema = yup.object({
    reference: referenceSchema
  }).required();
  return schema;
};

// src/validation/group.ts
import * as yup3 from "yup";

// src/validation/coding.ts
import * as yup2 from "yup";
var createCodeableConceptSchema = (supportedCodes) => yup2.object({
  coding: yup2.array(
    yup2.object({
      code: yup2.string().oneOf(supportedCodes).required()
    })
  ).required()
}).required();

// src/validation/group.ts
var resourceTypeSchema = yup3.string().equals(["Group"]).required();
var activeSchema = yup3.boolean().required();
var actualSchema = yup3.boolean().required();
var nameSchema = yup3.string().required().min(1);
var types = [
  "person",
  "animal",
  "device",
  "medication",
  "practitioner",
  "substance"
];
var typeSchema = yup3.string().oneOf(types).required();
var groupSecurityCodes = Object.values(GroupSecurity);
var groupTypeCodes = Object.values(GroupCode);
var codeSchema = createCodeableConceptSchema([...groupSecurityCodes, ...groupTypeCodes]);
var groupCreationSchema = yup3.object({
  active: activeSchema,
  actual: actualSchema,
  resourceType: resourceTypeSchema,
  code: codeSchema,
  name: nameSchema,
  type: typeSchema,
  member: yup3.object().is([void 0])
  // .default(undefined),
}).required();
var groupUpdateSchema = yup3.object({
  active: activeSchema,
  actual: actualSchema,
  resourceType: resourceTypeSchema,
  code: codeSchema,
  name: nameSchema,
  type: typeSchema,
  member: yup3.object().is([void 0])
}).required();
var allowedResourceTypes = [
  "Practitioner",
  "Patient",
  "PractitionerRole",
  "Device",
  "Medication",
  "Substance",
  "Group"
];
var groupUpdateMemberSchema = yup3.array(
  yup3.object({
    entity: createMultipleReferenceValidationSchema(allowedResourceTypes),
    inactive: yup3.boolean().required()
  })
);
export {
  AuditEventCode,
  AuditEventDescription,
  CHARGE_ITEM_DEFINITION_APPLICABILITY_LANGUAGE,
  CarePlanActivityCode,
  CarePlanActivityCodeDisplay,
  CareTeamRoleCode,
  CareTeamRoleDescription,
  CareTeamTypeCode,
  CareTeamTypeDescription,
  ChargeItemDefinitionCode,
  ClaimPriorityCode,
  ClaimResponseItemAdjudicationCategory,
  ClaimResponseTotalCategory,
  ClaimResponseTypeCode,
  ClaimTypeCode,
  ClinicalImpressionAssessmentValueCode,
  ClinicalImpressionCode,
  ClinicalImpressionInvestigationCode,
  ClinicalImpressionLocationCode,
  ClinicalImpressionNoteCode,
  ClinicalImpressionPlanValueCode,
  CommunicationAlertCode,
  ContentType,
  ContentTypeMap,
  CountryCode,
  CoverageClassCode,
  CoverageClassDisplayMapping,
  Currency,
  DeviceCode,
  DeviceLifecycleMap,
  DeviceMetricTypeCode,
  DeviceStatusReason,
  DeviceStatusReasonDescription,
  DeviceUseStatementCode,
  DiagnosisStatusCode,
  DiagnosisTypeCode,
  DiagnosticReportCode,
  DiagnosticReportIdentifier,
  DocumentTypeCode,
  DocumentTypeCodeDescription,
  DocumentTypeToTemplateType,
  EncounterClass,
  EncounterCode,
  EncounterDischargeReasonCode,
  EncounterInvalidateReasonCode,
  EncounterParticipantType,
  EncounterPausedReasonCode,
  EncounterService,
  EncounterType,
  Extension,
  ExtensionContentTypeMap,
  ExtensionUrl,
  FlagCode,
  GroupCode,
  GroupCodeDescription,
  GroupDescription,
  GroupSecurity,
  HumanNamePrefix,
  IdentifierCode,
  LanguagePreference,
  LanguagePreferenceDisplay,
  LocationAcuityCode,
  LocationAcuityDescription,
  LocationCodeDescription,
  LocationTypeCode,
  MediaUtils,
  MedicationRequestDosageInstructionAdministrationCode,
  MedicationType,
  MedicationTypeDisplay,
  MedicationTypeValue,
  MigrationCode,
  ObservationCode,
  ObservationCodeDescription,
  ObservationMeasurementCode,
  ObservationMeasurementUnits,
  OrganizationCode,
  OrganizationCodeDescription,
  PatientStatusCode,
  QuantityCode,
  QuestionnaireActionCode,
  RelatedPersonRelationship,
  RiskAssessmentTypeCode,
  RiskAssessmentTypeCodeDescription,
  ServiceRequestCode,
  ServiceRequestCodeDescription,
  ServiceRequestIdentifier,
  ServiceRequestPerformerDescription,
  ServiceRequestPerformerIdentifier,
  ServiceRequestType,
  TaskCode,
  TaskReferenceType,
  TemplateTypeCode,
  addExtensionToResource,
  addSubjectiveNote,
  allowedContentTypes,
  allowedDocumentExtensions,
  allowedExtensionTypeMap,
  allowedExtensions,
  ampathPerformerReference,
  ampathSystem,
  appendPostRequestToEntry,
  appendPutRequestToEntry,
  appendRequestToEntry,
  attachBundleFullUrl,
  carboneSystem,
  clinicalImpressionAssessmentValueCodeDisplay,
  clinicalImpressionPlanValueCodeDisplay,
  countryDisplayMapping,
  createAuditBundle,
  createAuditBundleWithMethods,
  createAuditEvent,
  createAuditResource,
  createAuditResourceReference,
  createBundle,
  createBundleEntry,
  createBundleReference,
  createChargeItemDefinitionApplicability,
  createCodeableConcept,
  createCoding,
  createDeviceRef,
  createDeviceUseStatementTimeframeFilter,
  createExtensionValue,
  createFhirDate,
  createFhirDateTime,
  createFullHumanName,
  createGroupMemberEntity,
  createGroupMemberEntityFromResource,
  createHumanName,
  createIdentifier,
  createMapWithId,
  createMultipleExtensions,
  createMultipleReferenceValidationSchema,
  createNoteAuditResources,
  createOptionalFhirDate,
  createOrganizationRef,
  createPatientRef,
  createPatientRefWithId,
  createPeriod,
  createPractitionerRef,
  createPractitionerRefWithId,
  createQuantityWithValue,
  createRandomResourceReference,
  createReference,
  createReferenceFromBundleEntry,
  createReferenceFromResource,
  createReferenceValidationSchema,
  createRegistrationIdentifier,
  createRelatedPersonRefWithId,
  createRiskExtension,
  createSystemIdentifier,
  createUnreferencedAuditPOSTResource,
  createUnreferencedAuditResource,
  createUrlReference,
  createValidOxygenRate,
  createVersionReference,
  createVersionReferenceFromResource,
  droppaSystem,
  encounterDischargeReasonCodeDisplay,
  encounterInvalidateReasonCodeDisplay,
  encounterPausedReasonCodeDisplay,
  encounterServiceClaimTypeMap,
  encounterServiceDisplay,
  fhirObservationInterpretationSystem,
  fillerEncountersByLocations,
  filterByRequestedPeriod,
  filterExtensionValues,
  filterExtensions,
  filterReferencesByType,
  findExtension,
  findExtensionValue,
  findIdentifier,
  findProp,
  findResourceByType,
  findResourcesByType,
  generateBundleReferenceId,
  getActiveGroupMembers,
  getAddressLines,
  getChargeItemDefinitionApplicabilityConditions,
  getCity,
  getCodes,
  getCodingsFromCodableConcepts,
  getCommon,
  getContactValues,
  getContentType,
  getCountry,
  getCreateReferenceId,
  getDeviceFriendlyName,
  getDeviceFriendlyNames,
  getDeviceIdFromDeviceUseStatements,
  getDeviceLifecycle,
  getDeviceName,
  getDeviceTypeCodes,
  getDeviceUseStatementOverlapPeriod,
  getDeviceUseStatementOverlapPeriods,
  getDeviceUseStatementsForDevice,
  getDevicesByCode,
  getDiff,
  getDisplayFromCodableConcepts,
  getDisplayName,
  getDisplayNameWithPrefix,
  getDuplicates,
  getDurationInDays,
  getEffectiveTimes,
  getEmail,
  getEmailFromPractitioner,
  getExtensionValue,
  getFirstCodeFromCodableConcepts,
  getFirstLine,
  getFirstValueWhere,
  getGroupReferences,
  getHomePhone,
  getIdQueryString,
  getIdentifier,
  getInvestigationReferencesByCode,
  getJointGroupSecurityCodes,
  getLifecycleForDeviceCode,
  getMobilePhone,
  getNameText,
  getNextLink,
  getNextPageToken,
  getOrganizationIds,
  getOrganizationReferences,
  getPageTokenFromBundle,
  getPatientNameDisplay,
  getPeriodDayWithPausePeriod,
  getPeriodDurationDays,
  getPersonName,
  getPersonNames,
  getPhone,
  getPlan,
  getPostalCode,
  getPractitionerName,
  getPrimaryPhoneNumber,
  getPrimaryPhoneNumberFromPractitioner,
  getQuantityWithValue,
  getReferenceData,
  getReferenceId,
  getReferenceType,
  getRelatedPersonNameDisplay,
  getResolvedReferenceId,
  getResourceId,
  getResourcesFromBundle,
  getRisk,
  getSecondaryNumbers,
  getSecondaryPhoneNumberFromPractitioner,
  getSubPlan,
  getSubjectsFromEncounters,
  getSubscriberType,
  getSupportedCode,
  getUserActiveGroupCodes,
  getVersionReferenceData,
  googleGemini2,
  groupCreationSchema,
  groupUpdateMemberSchema,
  groupUpdateSchema,
  hasEnd,
  hasId,
  hasQuantityValue,
  hasStart,
  iconoirSystem,
  isActiveDeviceUseStatement,
  isActiveGroupMember,
  isCodingInList,
  isDateWithinPeriod,
  isDeviceBand,
  isDeviceOfType,
  isDevicePatch,
  isDeviceRelay,
  isDeviceUseStatementActive,
  isDeviceUseStatementOfType,
  isFalsy,
  isGroupActive,
  isNotePinned,
  isOperationSuccessful,
  isPatientAssignedToPractitioner,
  isPatientAssignedToPractitionerGroup,
  isPatientAssignedToPractitionerOrGroups,
  isPatientMainMember,
  isPeriodComplete,
  isPractitionerMemberActive,
  isResourceType,
  isTruthy,
  isValidReference,
  isVersionReference,
  lancetPerformerReference,
  lancetSystem,
  loincSystem,
  mapDataToExtensions,
  mapDeviceUseStatementToSubjectAndDevice,
  mapExtensionsToData,
  mapFhirToModelPeriod,
  mapPatchToDevice,
  mapPhoneNumbersToTelecom,
  mapPrimaryNumberToTelecom,
  mapRelayToDevice,
  mapResourceToBundleEntry,
  mapResourceToEntry,
  mapSecondaryNumbersToTelecom,
  mapSecondaryTelecomToNumbers,
  medpraxSystem,
  mergeCodes,
  omitCommon,
  removeDuplicates,
  removeIdentifier,
  setDeviceUseStatementEnd,
  setTaskOverdue,
  system,
  twilioSystem,
  updateExtensions,
  updateGroupMembers,
  updateNoteAuditResources,
  updatedPinnedStatus,
  valsOrNone
};
//# sourceMappingURL=index.js.map